import * as i0 from '@angular/core';
import { Injectable, inject, Directive, Input, NgModule, Component, ChangeDetectionStrategy, HostListener, ComponentRef, Optional, ViewChild } from '@angular/core';
import { ReplaySubject, Subscription, race, of, combineLatest, merge } from 'rxjs';
import * as i1 from '@spartacus/cart/base/root';
import { AbstractOrderType, CartUiEventAddToCart, CartAddEntryFailEvent, CartAddEntrySuccessEvent, PromotionLocation, CartOutlets, CartItemContext, DeleteCartSuccessEvent, DeleteCartFailEvent, CartValidationStatusCode, OrderEntriesSource, ActiveCartOrderEntriesContextToken } from '@spartacus/cart/base/root';
import * as i2$1 from '@spartacus/storefront';
import { LAUNCH_CALLER, ICON_TYPE, IconModule, ItemCounterModule, OutletModule, FormErrorsModule, FormRequiredLegendComponent, AtMessageModule, MediaModule, PromotionsModule, provideOutlet, DIALOG_TYPE, SpinnerModule, KeyboardFocusModule, BtnLikeLinkModule, ProgressButtonModule, PAGE_LAYOUT_HANDLER } from '@spartacus/storefront';
import { take, map, filter, switchMap, startWith, tap, shareReplay, withLatestFrom } from 'rxjs/operators';
import * as i2 from '@spartacus/core';
import { useFeatureStyles, FeatureConfigService, FeatureToggles, ProductAvailabilityService, ProductScope, isNotNullable, I18nModule, FeaturesConfigModule, provideDefaultConfig, UrlModule, GlobalMessageType } from '@spartacus/core';
import * as i2$2 from '@angular/forms';
import { UntypedFormGroup, UntypedFormControl, ReactiveFormsModule, Validators, FormsModule } from '@angular/forms';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/router';
import { RouterModule, NavigationEnd, NavigationCancel } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import * as i3 from '@spartacus/cart/base/core';
import { isEmpty } from '@spartacus/cart/base/core';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Context source for AbstractOrderContext. Default values represent the context
 * of an active cart
 *
 * AbstractOrderContext should be injected in child components.
 */
const _c0 = a0 => ({
  quantity: a0
});
function CartItemValidationWarningComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "span", 3);
    i0.ɵɵelement(2, "cx-icon", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 5);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵlistener("click", function CartItemValidationWarningComponent_ng_container_0_div_1_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.isVisible = !ctx_r1.isVisible);
    });
    i0.ɵɵelement(8, "cx-icon", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const cartModification_r3 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.INFO);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(5, 4, "validation." + cartModification_r3.statusCode, i0.ɵɵpureFunction1(9, _c0, cartModification_r3.quantityAdded)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(7, 7, "common.close"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CLOSE);
  }
}
function CartItemValidationWarningComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CartItemValidationWarningComponent_ng_container_0_div_1_Template, 9, 11, "div", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isVisible);
  }
}
const _c1 = a0 => ({
  cxRoute: "product",
  params: a0
});
const _c2 = (a0, a1) => ({
  loading: a0,
  item: a1
});
const _c3 = a0 => ({
  $implicit: a0
});
function CartItemComponent_ng_template_0_ng_template_0_Template(rf, ctx) {}
function CartItemComponent_ng_template_0_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "a", 23);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵelementStart(3, "h3");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction1(4, _c1, ctx_r0.item.product)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.item.product == null ? null : ctx_r0.item.product.name);
  }
}
function CartItemComponent_ng_template_0_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "cartItems.id"), " ", ctx_r0.item.product == null ? null : ctx_r0.item.product.code, " ");
  }
}
function CartItemComponent_ng_template_0_ng_template_12_Template(rf, ctx) {}
function CartItemComponent_ng_template_0_ng_container_13_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const variant_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", variant_r2.name, ": ", variant_r2.value, " ");
  }
}
function CartItemComponent_ng_template_0_ng_container_13_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, CartItemComponent_ng_template_0_ng_container_13_div_1_div_1_Template, 2, 2, "div", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const variant_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", variant_r2.name && variant_r2.value);
  }
}
function CartItemComponent_ng_template_0_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CartItemComponent_ng_template_0_ng_container_13_div_1_Template, 2, 1, "div", 25);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.item.product == null ? null : ctx_r0.item.product.baseOptions[0] == null ? null : ctx_r0.item.product.baseOptions[0].selected == null ? null : ctx_r0.item.product.baseOptions[0].selected.variantOptionQualifiers);
  }
}
function CartItemComponent_ng_template_0_div_14_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.item.basePrice == null ? null : ctx_r0.item.basePrice.formattedValue, " ");
  }
}
function CartItemComponent_ng_template_0_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29)(1, "div", 30);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CartItemComponent_ng_template_0_div_14_div_4_Template, 2, 1, "div", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.compact ? "" : " col-md-3 col-lg-3 col-xl-2");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.compact ? "" : " d-block d-md-none d-lg-none d-xl-none");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "cartItems.itemPrice"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.item.basePrice);
  }
}
function CartItemComponent_ng_template_0_div_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 3, "cartItems.quantityTitle"));
    i0.ɵɵproperty("ngClass", ctx_r0.compact ? "" : " d-block d-md-none d-lg-none d-xl-none");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "cartItems.quantityFull"), " ");
  }
}
function CartItemComponent_ng_template_0_div_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 3, "cartItems.quantityTitle"));
    i0.ɵɵproperty("ngClass", ctx_r0.compact ? "" : " d-block d-md-none d-lg-none d-xl-none");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "cartItems.quantity"), " ");
  }
}
function CartItemComponent_ng_template_0_ng_container_20_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.item.product == null ? null : ctx_r0.item.product.stock == null ? null : ctx_r0.item.product.stock.stockLevel, " ");
  }
}
function CartItemComponent_ng_template_0_ng_container_20_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "saveForLaterItems.forceInStock"), " ");
  }
}
function CartItemComponent_ng_template_0_ng_container_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 33)(2, "div", 30);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CartItemComponent_ng_template_0_ng_container_20_div_5_Template, 2, 1, "div", 34)(6, CartItemComponent_ng_template_0_ng_container_20_ng_template_6_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const forceInstock_r3 = i0.ɵɵreference(7);
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.compact ? "" : " col-md-3 col-lg-3 col-xl-2");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.compact ? "" : " d-block d-md-none d-lg-none d-xl-none");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, "saveForLaterItems.stock"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r0.item.product == null ? null : ctx_r0.item.product.stock.stockLevel) >= 0)("ngIfElse", forceInstock_r3);
  }
}
function CartItemComponent_ng_template_0_div_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "addToCart.outOfStock"), " ");
  }
}
function CartItemComponent_ng_template_0_ng_template_22_Template(rf, ctx) {}
function CartItemComponent_ng_template_0_div_24_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CartItemComponent_ng_template_0_div_24_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CartItemComponent_ng_template_0_div_24_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 39);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.options.optionalBtn)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c3, i0.ɵɵpureFunction2(2, _c2, ctx_r0.quantityControl.disabled, ctx_r0.item)));
  }
}
function CartItemComponent_ng_template_0_div_24_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtemplate(1, CartItemComponent_ng_template_0_div_24_ng_container_1_Template, 2, 7, "ng-container", 12);
    i0.ɵɵelementStart(2, "div", 37)(3, "button", 38);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵlistener("click", function CartItemComponent_ng_template_0_div_24_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.removeItem());
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isProductOutOfStock(ctx_r0.item.product));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxAtMessage", i0.ɵɵpipeBind1(4, 5, "cartItems.itemRemoved"))("disabled", ctx_r0.quantityControl.disabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 7, "addToCart.removeFromCart"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 9, "common.remove"), " ");
  }
}
function CartItemComponent_ng_template_0_ng_template_25_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33)(1, "div", 30);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 16);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r0.compact ? "" : " col-md-3 col-xl-2");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.compact ? "" : " d-block d-md-none d-lg-none d-xl-none");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "cartItems.total"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.item.totalPrice.formattedValue);
  }
}
function CartItemComponent_ng_template_0_ng_template_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CartItemComponent_ng_template_0_ng_template_25_div_0_Template, 6, 6, "div", 40);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.item.totalPrice);
  }
}
function CartItemComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CartItemComponent_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 2);
    i0.ɵɵelement(1, "cx-cart-item-validation-warning", 3);
    i0.ɵɵelementStart(2, "div", 4)(3, "div", 5)(4, "a", 6);
    i0.ɵɵpipe(5, "cxUrl");
    i0.ɵɵelement(6, "cx-media", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 8)(8, "div", 9)(9, "div", 4);
    i0.ɵɵtemplate(10, CartItemComponent_ng_template_0_div_10_Template, 5, 6, "div", 10)(11, CartItemComponent_ng_template_0_div_11_Template, 3, 4, "div", 11)(12, CartItemComponent_ng_template_0_ng_template_12_Template, 0, 0, "ng-template", 2)(13, CartItemComponent_ng_template_0_ng_container_13_Template, 2, 1, "ng-container", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, CartItemComponent_ng_template_0_div_14_Template, 5, 6, "div", 13);
    i0.ɵɵelementStart(15, "div", 14);
    i0.ɵɵtemplate(16, CartItemComponent_ng_template_0_div_16_Template, 4, 7, "div", 15)(17, CartItemComponent_ng_template_0_div_17_Template, 4, 7, "div", 15);
    i0.ɵɵelementStart(18, "div", 16);
    i0.ɵɵelement(19, "cx-item-counter", 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(20, CartItemComponent_ng_template_0_ng_container_20_Template, 8, 7, "ng-container", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(21, CartItemComponent_ng_template_0_div_21_Template, 3, 3, "div", 19)(22, CartItemComponent_ng_template_0_ng_template_22_Template, 0, 0, "ng-template", 2);
    i0.ɵɵelement(23, "cx-promotions", 20);
    i0.ɵɵtemplate(24, CartItemComponent_ng_template_0_div_24_Template, 8, 11, "div", 21);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(25, CartItemComponent_ng_template_0_ng_template_25_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const total_r5 = i0.ɵɵreference(26);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cxOutlet", ctx_r0.CartOutlets.ITEM_CONFIGURATOR_ISSUES);
    i0.ɵɵadvance();
    i0.ɵɵproperty("code", ctx_r0.item.product == null ? null : ctx_r0.item.product.code);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.compact ? "cx-compact row" : "row");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(5, 26, i0.ɵɵpureFunction1(28, _c1, ctx_r0.item.product)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("container", ctx_r0.item.product == null ? null : ctx_r0.item.product.images == null ? null : ctx_r0.item.product.images.PRIMARY);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r0.compact ? "" : " col-md-3 col-lg-3 col-xl-5");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.item.product == null ? null : ctx_r0.item.product.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.item.product == null ? null : ctx_r0.item.product.code);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r0.CartOutlets.ITEM_DETAILS);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.item.product == null ? null : ctx_r0.item.product.baseOptions == null ? null : ctx_r0.item.product.baseOptions.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.item.basePrice);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.compact ? "" : " col-3");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yQTY2Quantity");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yQTY2Quantity");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("readonly-value", ctx_r0.readonly);
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r0.quantityControl)("readonly", !ctx_r0.item.updateable || ctx_r0.readonly || ctx_r0.options.isSaveForLater)("max", ctx_r0.item.product == null ? null : ctx_r0.item.product.stock == null ? null : ctx_r0.item.product.stock.stockLevel)("allowZero", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.options.isSaveForLater)("ngIfElse", total_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isProductOutOfStock(ctx_r0.item.product));
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r0.CartOutlets.ITEM_BUNDLE_DETAILS);
    i0.ɵɵadvance();
    i0.ɵɵproperty("promotions", ctx_r0.item.promotions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (!ctx_r0.readonly || ctx_r0.options.isSaveForLater) && ctx_r0.item.updateable);
  }
}
const _c4 = a0 => ({
  count: a0
});
const _c5 = () => [];
function AddedToCartDialogComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "addToCart.itemAddedToYourCart"), " ");
  }
}
function AddedToCartDialogComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r1.loaded$) ? i0.ɵɵpipeBind1(3, 3, ctx_r1.addedEntryWasMerged$) ? i0.ɵɵpipeBind1(4, 5, "addToCart.itemsIncrementedInYourCart") : i0.ɵɵpipeBind1(5, 7, "addToCart.itemsAddedToYourCart") : i0.ɵɵpipeBind1(6, 9, "addToCart.updatingCart"), " ");
  }
}
function AddedToCartDialogComponent_div_0_ng_container_10_div_1_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementStart(3, "span", 22);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "pickupOptionDialog.modalHeader"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.pickupStoreName);
  }
}
function AddedToCartDialogComponent_div_0_ng_container_10_div_1_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 24)(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 25);
    i0.ɵɵelement(8, "cx-promotions", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 27)(10, "button", 28);
    i0.ɵɵlistener("click", function AddedToCartDialogComponent_div_0_ng_container_10_div_1_div_7_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onAction("viewCart"));
    });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "button", 29);
    i0.ɵɵlistener("click", function AddedToCartDialogComponent_div_0_ng_container_10_div_1_div_7_Template_button_click_13_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onAction("checkout"));
    });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const cart_r4 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 9, "cartItems.cartTotal", i0.ɵɵpureFunction1(16, _c4, cart_r4.totalUnitCount)), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(cart_r4.subTotal == null ? null : cart_r4.subTotal.formattedValue);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("promotions", (cart_r4.appliedOrderPromotions || i0.ɵɵpureFunction0(18, _c5)).concat(cart_r4.potentialOrderPromotions || i0.ɵɵpureFunction0(19, _c5)));
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("disabled", ctx_r1.form.dirty);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 12, "addToCart.viewCart"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("disabled", ctx_r1.form.dirty);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 14, "addToCart.proceedToCheckout"), " ");
  }
}
function AddedToCartDialogComponent_div_0_ng_container_10_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15)(2, "div", 16);
    i0.ɵɵelement(3, "cx-cart-item", 17);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵtemplate(5, AddedToCartDialogComponent_div_0_ng_container_10_div_1_div_5_Template, 5, 4, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "div", 19);
    i0.ɵɵtemplate(7, AddedToCartDialogComponent_div_0_ng_container_10_div_1_div_7_Template, 16, 20, "div", 20);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const entry_r5 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("item", entry_r5)("compact", true)("quantityControl", i0.ɵɵpipeBind1(4, 6, ctx_r1.getQuantityControl()))("promotionLocation", ctx_r1.promotionLocation);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.pickupStoreName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 8, ctx_r1.cart$));
  }
}
function AddedToCartDialogComponent_div_0_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddedToCartDialogComponent_div_0_ng_container_10_div_1_Template, 9, 10, "div", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r1.entry$));
  }
}
function AddedToCartDialogComponent_div_0_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15)(2, "div", 30);
    i0.ɵɵelement(3, "cx-spinner", 8);
    i0.ɵɵelementEnd()()();
  }
}
function AddedToCartDialogComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵlistener("esc", function AddedToCartDialogComponent_div_0_Template_div_esc_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.dismissModal("Escape pressed"));
    });
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4);
    i0.ɵɵtemplate(3, AddedToCartDialogComponent_div_0_div_3_Template, 3, 3, "div", 5)(4, AddedToCartDialogComponent_div_0_div_4_Template, 7, 11, "div", 6);
    i0.ɵɵelementStart(5, "button", 7);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵlistener("click", function AddedToCartDialogComponent_div_0_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.dismissModal("Cross click"));
    });
    i0.ɵɵelementStart(8, "span", 8);
    i0.ɵɵelement(9, "cx-icon", 9);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(10, AddedToCartDialogComponent_div_0_ng_container_10_Template, 3, 3, "ng-container", 10);
    i0.ɵɵpipe(11, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, AddedToCartDialogComponent_div_0_ng_template_12_Template, 4, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const loading_r6 = i0.ɵɵreference(13);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cxFocus", ctx_r1.focusConfig);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "a11yUpdatingCartNoNarration");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yUpdatingCartNoNarration");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(6, 8, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(7, 10, "addToCart.closeModal"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CLOSE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(11, 12, ctx_r1.loaded$))("ngIfElse", loading_r6);
  }
}
function AddedToCartDialogComponent_div_1_ng_container_2_h3_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r1.addedEntryWasMerged$) ? i0.ɵɵpipeBind1(3, 3, "addToCart.itemsIncrementedInYourCart") : i0.ɵɵpipeBind1(4, 5, "addToCart.itemsAddedToYourCart"), " ");
  }
}
function AddedToCartDialogComponent_div_1_ng_container_2_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r1.addedEntryWasMerged$) ? i0.ɵɵpipeBind1(3, 3, "addToCart.itemsIncrementedInYourCart") : i0.ɵɵpipeBind1(4, 5, "addToCart.itemsAddedToYourCart"), " ");
  }
}
function AddedToCartDialogComponent_div_1_ng_container_2_div_9_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementStart(3, "span", 22);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "pickupOptionDialog.modalHeader"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.pickupStoreName);
  }
}
function AddedToCartDialogComponent_div_1_ng_container_2_div_9_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 24)(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 25);
    i0.ɵɵelement(8, "cx-promotions", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 27)(10, "button", 28);
    i0.ɵɵlistener("click", function AddedToCartDialogComponent_div_1_ng_container_2_div_9_div_7_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onAction("viewCart"));
    });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "button", 29);
    i0.ɵɵlistener("click", function AddedToCartDialogComponent_div_1_ng_container_2_div_9_div_7_Template_button_click_13_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onAction("checkout"));
    });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const cart_r10 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 9, "cartItems.cartTotal", i0.ɵɵpureFunction1(16, _c4, cart_r10.totalUnitCount)), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(cart_r10.subTotal == null ? null : cart_r10.subTotal.formattedValue);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("promotions", (cart_r10.appliedOrderPromotions || i0.ɵɵpureFunction0(18, _c5)).concat(cart_r10.potentialOrderPromotions || i0.ɵɵpureFunction0(19, _c5)));
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("disabled", ctx_r1.form.dirty);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 12, "addToCart.viewCart"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("disabled", ctx_r1.form.dirty);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 14, "addToCart.proceedToCheckout"), " ");
  }
}
function AddedToCartDialogComponent_div_1_ng_container_2_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15)(2, "div", 16);
    i0.ɵɵelement(3, "cx-cart-item", 17);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵtemplate(5, AddedToCartDialogComponent_div_1_ng_container_2_div_9_div_5_Template, 5, 4, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "div", 19);
    i0.ɵɵtemplate(7, AddedToCartDialogComponent_div_1_ng_container_2_div_9_div_7_Template, 16, 20, "div", 20);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const entry_r11 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("item", entry_r11)("compact", true)("quantityControl", i0.ɵɵpipeBind1(4, 6, ctx_r1.getQuantityControl()))("promotionLocation", ctx_r1.promotionLocation);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.pickupStoreName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 8, ctx_r1.cart$));
  }
}
function AddedToCartDialogComponent_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵtemplate(2, AddedToCartDialogComponent_div_1_ng_container_2_h3_2_Template, 5, 7, "h3", 6)(3, AddedToCartDialogComponent_div_1_ng_container_2_div_3_Template, 5, 7, "div", 6);
    i0.ɵɵelementStart(4, "button", 7);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵlistener("click", function AddedToCartDialogComponent_div_1_ng_container_2_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.dismissModal("Cross click"));
    });
    i0.ɵɵelementStart(7, "span", 8);
    i0.ɵɵelement(8, "cx-icon", 9);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(9, AddedToCartDialogComponent_div_1_ng_container_2_div_9_Template, 9, 10, "div", 13);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "a11yDialogsHeading");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yDialogsHeading");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(5, 6, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 8, "addToCart.closeModal"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CLOSE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(10, 10, ctx_r1.entry$));
  }
}
function AddedToCartDialogComponent_div_1_ng_template_4_h2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 34);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "addToCart.updatingCart"), " ");
  }
}
function AddedToCartDialogComponent_div_1_ng_template_4_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "addToCart.updatingCart"), " ");
  }
}
function AddedToCartDialogComponent_div_1_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtemplate(1, AddedToCartDialogComponent_div_1_ng_template_4_h2_1_Template, 3, 3, "h2", 33)(2, AddedToCartDialogComponent_div_1_ng_template_4_div_2_Template, 3, 3, "div", 33);
    i0.ɵɵelementStart(3, "button", 7);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵlistener("click", function AddedToCartDialogComponent_div_1_ng_template_4_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.dismissModal("Cross click"));
    });
    i0.ɵɵelementStart(6, "span", 8);
    i0.ɵɵelement(7, "cx-icon", 9);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "div", 14)(9, "div", 15)(10, "div", 30);
    i0.ɵɵelement(11, "cx-spinner");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yDialogsHeading");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yDialogsHeading");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(4, 5, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 7, "common.close"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CLOSE);
  }
}
function AddedToCartDialogComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵlistener("esc", function AddedToCartDialogComponent_div_1_Template_div_esc_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.dismissModal("Escape pressed"));
    });
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtemplate(2, AddedToCartDialogComponent_div_1_ng_container_2_Template, 11, 12, "ng-container", 10);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, AddedToCartDialogComponent_div_1_ng_template_4_Template, 12, 9, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(6, "div", 31);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const loading_r13 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cxFocus", ctx_r1.focusConfig);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx_r1.loaded$))("ngIfElse", loading_r13);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 6, ctx_r1.addedEntryWasMerged$) ? i0.ɵɵpipeBind1(9, 8, "addToCart.itemsIncrementedInYourCart") : i0.ɵɵpipeBind1(10, 10, "addToCart.itemsAddedToYourCart"), " ");
  }
}
const _c6 = ["addToCartDialogTriggerEl"];
function AddToCartComponent_form_0_div_1_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "addToCart.quantityFull"));
  }
}
function AddToCartComponent_form_0_div_1_label_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "addToCart.quantity"));
  }
}
function AddToCartComponent_form_0_div_1_cx_item_counter_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-item-counter", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("max", ctx_r1.maxQuantity)("control", ctx_r1.addToCartForm.get("quantity"))("ariaDescribedById", "add-to-card-stock-info");
  }
}
function AddToCartComponent_form_0_div_1_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getInventory());
  }
}
function AddToCartComponent_form_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, AddToCartComponent_form_0_div_1_label_1_Template, 3, 3, "label", 7)(2, AddToCartComponent_form_0_div_1_label_2_Template, 3, 3, "label", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtemplate(4, AddToCartComponent_form_0_div_1_cx_item_counter_4_Template, 1, 3, "cx-item-counter", 9);
    i0.ɵɵelementStart(5, "span", 10);
    i0.ɵɵtemplate(6, AddToCartComponent_form_0_div_1_span_6_Template, 2, 1, "span", 4);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yQTY2Quantity");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yQTY2Quantity");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.hasStock);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 5, ctx_r1.showInventory$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.hasStock ? i0.ɵɵpipeBind1(9, 7, "addToCart.inStock") : i0.ɵɵpipeBind1(10, 9, "addToCart.outOfStock"), "");
  }
}
function AddToCartComponent_form_0_ng_container_2_ng_template_1_Template(rf, ctx) {}
function AddToCartComponent_form_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddToCartComponent_form_0_ng_container_2_ng_template_1_Template, 0, 0, "ng-template", 12);
    i0.ɵɵtwoWayListener("cxComponentRefChange", function AddToCartComponent_form_0_ng_container_2_Template_ng_template_cxComponentRefChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.pickupOptionCompRef, $event) || (ctx_r1.pickupOptionCompRef = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("cxComponentRefChange", function AddToCartComponent_form_0_ng_container_2_Template_ng_template_cxComponentRefChange_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onPickupOptionsCompLoaded());
    });
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r1.CartOutlets.ADD_TO_CART_PICKUP_OPTION);
    i0.ɵɵtwoWayProperty("cxComponentRef", ctx_r1.pickupOptionCompRef);
  }
}
function AddToCartComponent_form_0_button_3_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵelement(1, "cx-icon", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.iconTypes.REPEAT);
  }
}
function AddToCartComponent_form_0_button_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 13, 0);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵtemplate(4, AddToCartComponent_form_0_button_3_span_4_Template, 2, 1, "span", 14);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementStart(6, "span", 15);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_8_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", (ctx_r1.options == null ? null : ctx_r1.options.displayAddToCart) ? "btn btn-tertiary" : "btn btn-primary btn-block")("disabled", ctx_r1.disabled || ctx_r1.quantity <= 0 || ctx_r1.quantity > ctx_r1.maxQuantity);
    i0.ɵɵattribute("aria-label", (ctx_r1.product == null ? null : ctx_r1.product.name) ? i0.ɵɵpipeBind1(2, 6, "addToCart.addToCart") + ", " + (ctx_r1.product == null ? null : ctx_r1.product.name) : i0.ɵɵpipeBind1(3, 8, "addToCart.addToCart"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (ctx_r1.options == null ? null : ctx_r1.options.addToCartString) === i0.ɵɵpipeBind1(5, 10, "addToCart.buyItAgain"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", (ctx_r1.options == null ? null : ctx_r1.options.addToCartString) === i0.ɵɵpipeBind1(7, 12, "addToCart.buyItAgain") ? "buyItAgainLink" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (tmp_8_0 = ctx_r1.options == null ? null : ctx_r1.options.addToCartString) !== null && tmp_8_0 !== undefined ? tmp_8_0 : i0.ɵɵpipeBind1(9, 14, "addToCart.addToCart"), " ");
  }
}
function AddToCartComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 2);
    i0.ɵɵlistener("submit", function AddToCartComponent_form_0_Template_form_submit_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addToCart());
    });
    i0.ɵɵtemplate(1, AddToCartComponent_form_0_div_1_Template, 11, 11, "div", 3)(2, AddToCartComponent_form_0_ng_container_2_Template, 2, 2, "ng-container", 4)(3, AddToCartComponent_form_0_button_3_Template, 10, 16, "button", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.addToCartForm);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showQuantity);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hasStock);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hasStock);
  }
}
function AppliedCouponsComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "voucher.vouchersApplied"), " ");
  }
}
function AppliedCouponsComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "span", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const voucher_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(voucher_r1.voucherCode);
  }
}
function AppliedCouponsComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AppliedCouponsComponent_div_0_div_1_Template, 4, 3, "div", 2);
    i0.ɵɵelementContainerStart(2);
    i0.ɵɵtemplate(3, AppliedCouponsComponent_div_0_div_3_Template, 3, 1, "div", 3);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.sortedVouchers.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.sortedVouchers);
  }
}
function AppliedCouponsComponent_ng_template_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "span", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 12);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵlistener("click", function AppliedCouponsComponent_ng_template_1_div_2_Template_button_click_4_listener() {
      const voucher_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.removeVoucher(voucher_r4.voucherCode));
    });
    i0.ɵɵelementStart(7, "span", 13);
    i0.ɵɵelement(8, "cx-icon", 14);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const voucher_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(voucher_r4.voucherCode);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("disabled", ctx_r1.cartIsLoading);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(5, 7, "common.close"));
    i0.ɵɵproperty("disabled", ctx_r1.cartIsLoading);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 9, "common.close"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CLOSE);
  }
}
function AppliedCouponsComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementContainerStart(1);
    i0.ɵɵtemplate(2, AppliedCouponsComponent_ng_template_1_div_2_Template, 9, 11, "div", 8);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.sortedVouchers);
  }
}
function CartCouponComponent_ng_container_0_ng_container_16_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "button", 14);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵlistener("click", function CartCouponComponent_ng_container_0_ng_container_16_div_9_Template_button_click_1_listener() {
      const coupon_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.applyCustomerCoupon(coupon_r4.couponId));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const coupon_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("disabled", i0.ɵɵpipeBind1(2, 4, ctx_r1.cartIsLoading$));
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(3, 6, ctx_r1.cartIsLoading$));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", coupon_r4.couponId, " ");
  }
}
function CartCouponComponent_ng_container_0_ng_container_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 8)(2, "div", 9);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 10);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 11);
    i0.ɵɵtemplate(9, CartCouponComponent_ng_container_0_ng_container_16_div_9_Template, 5, 8, "div", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, "voucher.availableCoupons"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 5, "voucher.availableCouponsLabel"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.applicableCoupons);
  }
}
function CartCouponComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "form", 2);
    i0.ɵɵlistener("ngSubmit", function CartCouponComponent_ng_container_0_Template_form_ngSubmit_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.applyVoucher());
    });
    i0.ɵɵelementStart(3, "label", 3);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 4);
    i0.ɵɵelement(7, "input", 5);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementStart(9, "button", 6);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵpipe(11, "async");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelement(14, "cx-applied-coupons", 7);
    i0.ɵɵpipe(15, "async");
    i0.ɵɵtemplate(16, CartCouponComponent_ng_container_0_ng_container_16_Template, 10, 7, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_7_0;
    const cart_r5 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formGroup", ctx_r1.couponForm);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 12, "voucher.addCoupon"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(8, 14, "voucher.placeholder"));
    i0.ɵɵattribute("aria-labelledby", "card-coupon-input-label");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("disabled", i0.ɵɵpipeBind1(10, 16, ctx_r1.cartIsLoading$));
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(11, 18, ctx_r1.cartIsLoading$) || !(ctx_r1.couponForm == null ? null : (tmp_7_0 = ctx_r1.couponForm.get("couponCode")) == null ? null : tmp_7_0.value));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 20, "voucher.apply"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("vouchers", cart_r5.appliedVouchers)("cartIsLoading", i0.ɵɵpipeBind1(15, 22, ctx_r1.cartIsLoading$))("isReadOnly", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.applicableCoupons && ctx_r1.applicableCoupons.length > 0);
  }
}
const _c7 = ["cx-cart-item-list-row", ""];
const _c8 = a0 => ({
  items: a0
});
const _c9 = (a0, a1) => ({
  item: a0,
  cartType: a1
});
const _c10 = (a0, a1, a2) => ({
  loading: a0,
  item: a1,
  options: a2
});
function CartItemListRowComponent_ng_template_0_ng_template_1_Template(rf, ctx) {}
function CartItemListRowComponent_ng_template_0_a_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 23);
    i0.ɵɵpipe(1, "cxUrl");
    i0.ɵɵelement(2, "cx-media", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 2, i0.ɵɵpureFunction1(4, _c1, ctx_r0.item.product)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("container", ctx_r0.item.product == null ? null : ctx_r0.item.product.images == null ? null : ctx_r0.item.product.images.PRIMARY);
  }
}
function CartItemListRowComponent_ng_template_0_cx_media_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-media", 24);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("container", ctx_r0.item.product == null ? null : ctx_r0.item.product.images == null ? null : ctx_r0.item.product.images.PRIMARY);
  }
}
function CartItemListRowComponent_ng_template_0_div_7_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 27);
    i0.ɵɵpipe(1, "cxUrl");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 2, i0.ɵɵpureFunction1(4, _c1, ctx_r0.item.product)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.item.product == null ? null : ctx_r0.item.product.name);
  }
}
function CartItemListRowComponent_ng_template_0_div_7_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.item.product == null ? null : ctx_r0.item.product.name);
  }
}
function CartItemListRowComponent_ng_template_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, CartItemListRowComponent_ng_template_0_div_7_a_1_Template, 3, 6, "a", 26)(2, CartItemListRowComponent_ng_template_0_div_7_span_2_Template, 2, 1, "span", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.options.disableItemLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.options.disableItemLink);
  }
}
function CartItemListRowComponent_ng_template_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "cartItems.id"), " ", ctx_r0.item.product == null ? null : ctx_r0.item.product.code, " ");
  }
}
function CartItemListRowComponent_ng_template_0_ng_container_9_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.item.basePrice == null ? null : ctx_r0.item.basePrice.formattedValue, " ");
  }
}
function CartItemListRowComponent_ng_template_0_ng_container_9_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, CartItemListRowComponent_ng_template_0_ng_container_9_div_1_div_1_Template, 2, 1, "div", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.item.basePrice);
  }
}
function CartItemListRowComponent_ng_template_0_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CartItemListRowComponent_ng_template_0_ng_container_9_div_1_Template, 2, 1, "div", 29);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.item.basePrice);
  }
}
function CartItemListRowComponent_ng_template_0_ng_template_10_Template(rf, ctx) {}
function CartItemListRowComponent_ng_template_0_ng_template_12_Template(rf, ctx) {}
function CartItemListRowComponent_ng_template_0_ng_template_13_Template(rf, ctx) {}
function CartItemListRowComponent_ng_template_0_15_ng_template_0_Template(rf, ctx) {}
function CartItemListRowComponent_ng_template_0_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CartItemListRowComponent_ng_template_0_15_ng_template_0_Template, 0, 0, "ng-template", 32);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cxOutlet", ctx_r0.CartOutlets.ITEM_DELIVERY_DETAILS)("cxOutletContext", i0.ɵɵpureFunction2(2, _c9, ctx_r0.item, ctx_r0.options.cartType));
  }
}
function CartItemListRowComponent_ng_template_0_ng_container_16_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const variant_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", variant_r2.name, ": ", variant_r2.value, " ");
  }
}
function CartItemListRowComponent_ng_template_0_ng_container_16_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtemplate(1, CartItemListRowComponent_ng_template_0_ng_container_16_div_1_div_1_Template, 2, 2, "div", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const variant_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", variant_r2.name && variant_r2.value);
  }
}
function CartItemListRowComponent_ng_template_0_ng_container_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CartItemListRowComponent_ng_template_0_ng_container_16_div_1_Template, 2, 1, "div", 33);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.item.product == null ? null : ctx_r0.item.product.baseOptions[0] == null ? null : ctx_r0.item.product.baseOptions[0].selected == null ? null : ctx_r0.item.product.baseOptions[0].selected.variantOptionQualifiers);
  }
}
function CartItemListRowComponent_ng_template_0_td_17_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.item.basePrice == null ? null : ctx_r0.item.basePrice.formattedValue, " ");
  }
}
function CartItemListRowComponent_ng_template_0_td_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 37)(1, "div", 38);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CartItemListRowComponent_ng_template_0_td_17_div_4_Template, 2, 1, "div", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "cartItems.itemPrice"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.item.basePrice);
  }
}
function CartItemListRowComponent_ng_template_0_ng_template_18_Template(rf, ctx) {}
function CartItemListRowComponent_ng_template_0_div_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 2, "cartItems.quantityTitle"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "cartItems.quantityFull"), " ");
  }
}
function CartItemListRowComponent_ng_template_0_div_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 2, "cartItems.quantityTitle"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "cartItems.quantity"), " ");
  }
}
function CartItemListRowComponent_ng_template_0_ng_container_24_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.item.product == null ? null : ctx_r0.item.product.stock.stockLevel, " ");
  }
}
function CartItemListRowComponent_ng_template_0_ng_container_24_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "saveForLaterItems.forceInStock"), " ");
  }
}
function CartItemListRowComponent_ng_template_0_ng_container_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "td", 40)(2, "div", 38);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CartItemListRowComponent_ng_template_0_ng_container_24_div_5_Template, 2, 1, "div", 41)(6, CartItemListRowComponent_ng_template_0_ng_container_24_ng_template_6_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const forceInstock_r3 = i0.ɵɵreference(7);
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, "saveForLaterItems.stock"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r0.item.product == null ? null : ctx_r0.item.product.stock == null ? null : ctx_r0.item.product.stock.stockLevel) >= 0)("ngIfElse", forceInstock_r3);
  }
}
function CartItemListRowComponent_ng_template_0_td_25_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CartItemListRowComponent_ng_template_0_td_25_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CartItemListRowComponent_ng_template_0_td_25_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 45);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.options.optionalBtn)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c3, i0.ɵɵpureFunction3(2, _c10, ctx_r0.quantityControl.disabled, ctx_r0.item, ctx_r0.options)));
  }
}
function CartItemListRowComponent_ng_template_0_td_25_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 46);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "addToCart.outOfStock"), " ");
  }
}
function CartItemListRowComponent_ng_template_0_td_25_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 47);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function CartItemListRowComponent_ng_template_0_td_25_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.removeItem());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("cxAtMessage", i0.ɵɵpipeBind1(1, 4, "cartItems.itemRemoved"))("disabled", ctx_r0.quantityControl.disabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 6, "addToCart.removeFromCart"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 8, "common.remove"), " ");
  }
}
function CartItemListRowComponent_ng_template_0_td_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 42);
    i0.ɵɵtemplate(1, CartItemListRowComponent_ng_template_0_td_25_ng_container_1_Template, 2, 8, "ng-container", 11)(2, CartItemListRowComponent_ng_template_0_td_25_span_2_Template, 3, 3, "span", 43)(3, CartItemListRowComponent_ng_template_0_td_25_button_3_Template, 5, 10, "button", 44);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isProductOutOfStock(ctx_r0.item.product));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isProductOutOfStock(ctx_r0.item.product));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.readonly);
  }
}
function CartItemListRowComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 3);
    i0.ɵɵtemplate(1, CartItemListRowComponent_ng_template_0_ng_template_1_Template, 0, 0, "ng-template", 2);
    i0.ɵɵelement(2, "cx-cart-item-validation-warning", 4);
    i0.ɵɵelementStart(3, "div", 5);
    i0.ɵɵtemplate(4, CartItemListRowComponent_ng_template_0_a_4_Template, 3, 6, "a", 6)(5, CartItemListRowComponent_ng_template_0_cx_media_5_Template, 1, 1, "cx-media", 7);
    i0.ɵɵelementStart(6, "div", 8);
    i0.ɵɵtemplate(7, CartItemListRowComponent_ng_template_0_div_7_Template, 3, 2, "div", 9)(8, CartItemListRowComponent_ng_template_0_div_8_Template, 3, 4, "div", 10)(9, CartItemListRowComponent_ng_template_0_ng_container_9_Template, 2, 1, "ng-container", 11)(10, CartItemListRowComponent_ng_template_0_ng_template_10_Template, 0, 0, "ng-template", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 13);
    i0.ɵɵtemplate(12, CartItemListRowComponent_ng_template_0_ng_template_12_Template, 0, 0, "ng-template", 2)(13, CartItemListRowComponent_ng_template_0_ng_template_13_Template, 0, 0, "ng-template", 2);
    i0.ɵɵelement(14, "cx-promotions", 14);
    i0.ɵɵtemplate(15, CartItemListRowComponent_ng_template_0_15_Template, 1, 5, null, 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, CartItemListRowComponent_ng_template_0_ng_container_16_Template, 2, 1, "ng-container", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, CartItemListRowComponent_ng_template_0_td_17_Template, 5, 4, "td", 15)(18, CartItemListRowComponent_ng_template_0_ng_template_18_Template, 0, 0, "ng-template", 16);
    i0.ɵɵelementStart(19, "td", 17);
    i0.ɵɵtemplate(20, CartItemListRowComponent_ng_template_0_div_20_Template, 4, 6, "div", 18)(21, CartItemListRowComponent_ng_template_0_div_21_Template, 4, 6, "div", 18);
    i0.ɵɵelementStart(22, "div", 19);
    i0.ɵɵelement(23, "cx-item-counter", 20);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(24, CartItemListRowComponent_ng_template_0_ng_container_24_Template, 8, 5, "ng-container", 21)(25, CartItemListRowComponent_ng_template_0_td_25_Template, 4, 3, "td", 22);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const total_r5 = i0.ɵɵreference(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r0.CartOutlets.ITEM_CONFIGURATOR_ISSUES);
    i0.ɵɵadvance();
    i0.ɵɵproperty("code", ctx_r0.item.product == null ? null : ctx_r0.item.product.code);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.options.disableItemLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.options.disableItemLink);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.item.product == null ? null : ctx_r0.item.product.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.item.product == null ? null : ctx_r0.item.product.code);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isFlagQuote);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r0.CartOutlets.CPQ_QUOTE)("cxOutletContext", i0.ɵɵpureFunction1(28, _c8, ctx_r0.item));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxOutlet", ctx_r0.CartOutlets.ITEM_DETAILS);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r0.CartOutlets.ITEM_BUNDLE_DETAILS);
    i0.ɵɵadvance();
    i0.ɵɵproperty("promotions", ctx_r0.item.promotions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.readonly);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.item.product == null ? null : ctx_r0.item.product.baseOptions == null ? null : ctx_r0.item.product.baseOptions.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.item.basePrice);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r0.CartOutlets.CPQ_QUOTE_MODULE)("cxOutletContext", i0.ɵɵpureFunction1(30, _c8, ctx_r0.item));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "a11yQTY2Quantity");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yQTY2Quantity");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("readonly-value", ctx_r0.readonly);
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r0.quantityControl)("readonly", !ctx_r0.item.updateable || ctx_r0.readonly || ctx_r0.options.isSaveForLater)("max", ctx_r0.item.product == null ? null : ctx_r0.item.product.stock == null ? null : ctx_r0.item.product.stock.stockLevel)("allowZero", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.options.isSaveForLater)("ngIfElse", total_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (!ctx_r0.readonly || ctx_r0.options.isSaveForLater || ctx_r0.options.displayAddToCart) && ctx_r0.item.updateable);
  }
}
function CartItemListRowComponent_ng_template_1_td_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 40)(1, "div", 38);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 19);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "cartItems.total"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.item.totalPrice.formattedValue);
  }
}
function CartItemListRowComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CartItemListRowComponent_ng_template_1_td_0_Template, 6, 4, "td", 48);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.item.totalPrice);
  }
}
function CartItemListComponent_thead_4_ng_template_5_Template(rf, ctx) {}
function CartItemListComponent_thead_4_th_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 11);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cartItems.quantityFull"), " ");
  }
}
function CartItemListComponent_thead_4_th_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 11);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cartItems.quantity"), " ");
  }
}
function CartItemListComponent_thead_4_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "th", 12);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "saveForLaterItems.stock"), " ");
  }
}
function CartItemListComponent_thead_4_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "th", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "cartItems.actions"), " ");
  }
}
function CartItemListComponent_thead_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "thead")(1, "tr", 6)(2, "th", 7);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CartItemListComponent_thead_4_ng_template_5_Template, 0, 0, "ng-template", 8)(6, CartItemListComponent_thead_4_th_6_Template, 3, 3, "th", 9)(7, CartItemListComponent_thead_4_th_7_Template, 3, 3, "th", 9)(8, CartItemListComponent_thead_4_ng_container_8_Template, 4, 3, "ng-container", 10)(9, CartItemListComponent_thead_4_ng_container_9_Template, 4, 3, "ng-container", 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const totalHeader_r2 = i0.ɵɵreference(8);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 8, "cartItems.item"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxOutlet", ctx_r0.CartOutlets.CPQ_QUOTE_HEADING)("cxOutletContext", ctx_r0.items);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yQTY2Quantity");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yQTY2Quantity");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.options.isSaveForLater)("ngIfElse", totalHeader_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.readonly || ctx_r0.options.isSaveForLater || ctx_r0.options.displayAddToCart);
  }
}
function CartItemListComponent_ng_container_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "tr", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const control_r3 = ctx.ngIf;
    const ctx_r3 = i0.ɵɵnextContext();
    const item_r5 = ctx_r3.$implicit;
    const i_r6 = ctx_r3.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("is-changed", control_r3.get("quantity").disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("item", item_r5)("quantityControl", control_r3.get("quantity"))("readonly", ctx_r0.readonly)("promotionLocation", ctx_r0.promotionLocation)("options", ctx_r0.options);
    i0.ɵɵattribute("aria-rowindex", i_r6 + 1);
  }
}
function CartItemListComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CartItemListComponent_ng_container_6_ng_container_1_Template, 2, 8, "ng-container", 14);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r0.getControl(item_r5)));
  }
}
function CartItemListComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cartItems.total"), " ");
  }
}
function OrderSummaryComponent_div_3_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 7);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "orderCost.salesTax"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.cart.totalTax == null ? null : ctx_r0.cart.totalTax.formattedValue, " ");
  }
}
function OrderSummaryComponent_div_3_div_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "orderCost.discount"), " ", ctx_r0.cart.totalDiscounts == null ? null : ctx_r0.cart.totalDiscounts.formattedValue, " ");
  }
}
function OrderSummaryComponent_div_3_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", (ctx_r0.cart.totalPriceWithTax == null ? null : ctx_r0.cart.totalPriceWithTax.value) !== (ctx_r0.cart.totalPrice == null ? null : ctx_r0.cart.totalPrice.value) ? i0.ɵɵpipeBind1(2, 2, "orderCost.grossTax") : i0.ɵɵpipeBind1(3, 4, "orderCost.grossIncludeTax"), " ", ctx_r0.cart.totalTax == null ? null : ctx_r0.cart.totalTax.formattedValue, ". ");
  }
}
function OrderSummaryComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "div", 6);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 5)(8, "div", 6);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 7);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(14, OrderSummaryComponent_div_3_div_14_Template, 6, 4, "div", 8);
    i0.ɵɵelementStart(15, "div", 9)(16, "div", 6);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 7);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(21, OrderSummaryComponent_div_3_div_21_Template, 3, 4, "div", 10)(22, OrderSummaryComponent_div_3_ng_template_22_Template, 4, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const cartWithoutNet_r2 = i0.ɵɵreference(23);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 9, "orderCost.subtotal"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.cart.subTotal == null ? null : ctx_r0.cart.subTotal.formattedValue, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 11, (ctx_r0.cart.deliveryCost == null ? null : ctx_r0.cart.deliveryCost.formattedValue) ? "orderCost.shipping" : "orderCost.estimatedShipping"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (ctx_r0.cart.deliveryCost == null ? null : ctx_r0.cart.deliveryCost.formattedValue) ? ctx_r0.cart.deliveryCost == null ? null : ctx_r0.cart.deliveryCost.formattedValue : i0.ɵɵpipeBind1(13, 13, "orderCost.toBeDetermined"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.cart.net)("ngIfElse", cartWithoutNet_r2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 15, "orderCost.total"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.cart.totalPriceWithTax == null ? null : ctx_r0.cart.totalPriceWithTax.formattedValue, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.cart.totalDiscounts == null ? null : ctx_r0.cart.totalDiscounts.value) > 0);
  }
}
const _c11 = ["element"];
function ClearCartComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "button", 4, 0);
    i0.ɵɵlistener("click", function ClearCartComponent_ng_container_0_div_1_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.openDialog($event));
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "clearCart.clearCart"), " ");
  }
}
function ClearCartComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ClearCartComponent_ng_container_0_div_1_Template, 5, 3, "div", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cart_r3 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", cart_r3.totalItems > 0);
  }
}
function ClearCartDialogComponent_ng_container_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function ClearCartDialogComponent_ng_container_2_h3_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 17);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "clearCart.clearCart"), " ");
  }
}
function ClearCartDialogComponent_ng_container_2_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "clearCart.clearCart"), " ");
  }
}
function ClearCartDialogComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ClearCartDialogComponent_ng_container_2_div_1_Template, 2, 3, "div", 4);
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵtemplate(3, ClearCartDialogComponent_ng_container_2_h3_3_Template, 3, 3, "h3", 6)(4, ClearCartDialogComponent_ng_container_2_div_4_Template, 3, 3, "div", 6);
    i0.ɵɵelementStart(5, "button", 7);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵlistener("click", function ClearCartDialogComponent_ng_container_2_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close("Close Clear Cart Dialog"));
    });
    i0.ɵɵelementStart(8, "span", 8);
    i0.ɵɵelement(9, "cx-icon", 9);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "div", 10)(11, "div", 11);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 12);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div")(18, "div", 13)(19, "button", 14);
    i0.ɵɵlistener("click", function ClearCartDialogComponent_ng_container_2_Template_button_click_19_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close("Cancel Clear Cart"));
    });
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "button", 15);
    i0.ɵɵlistener("click", function ClearCartDialogComponent_ng_container_2_Template_button_click_22_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clearCart());
    });
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "cxTranslate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "a11yDialogsHeading");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yDialogsHeading");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(6, 10, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(7, 12, "common.close"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.CLOSE);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 14, "clearCart.allItemsWillBeRemoved"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 16, "clearCart.areYouSureToClearCart"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 18, "common.cancel"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 20, "clearCart.clearCart"), " ");
  }
}
function ClearCartDialogComponent_ng_template_3_h2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 20);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "clearCart.clearingCart"), " ");
  }
}
function ClearCartDialogComponent_ng_template_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "clearCart.clearingCart"), " ");
  }
}
function ClearCartDialogComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, ClearCartDialogComponent_ng_template_3_h2_1_Template, 3, 3, "h2", 18)(2, ClearCartDialogComponent_ng_template_3_div_2_Template, 3, 3, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 19);
    i0.ɵɵelement(4, "cx-spinner");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yDialogsHeading");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yDialogsHeading");
  }
}
function CartValidationWarningsComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "span", 3);
    i0.ɵɵelement(2, "cx-icon", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span")(4, "a", 5);
    i0.ɵɵpipe(5, "cxUrl");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 6);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵlistener("click", function CartValidationWarningsComponent_ng_container_0_div_1_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const cartModification_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.removeMessage(cartModification_r2));
    });
    i0.ɵɵelement(12, "cx-icon", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const cartModification_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.ERROR);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(5, 7, i0.ɵɵpureFunction1(15, _c1, cartModification_r2.entry.product)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", cartModification_r2.entry.product.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 9, "validation.productOutOfStock"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(10, 11, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(11, 13, "common.close"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.CLOSE);
  }
}
function CartValidationWarningsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CartValidationWarningsComponent_ng_container_0_div_1_Template, 13, 17, "div", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cartModification_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.visibleWarnings[cartModification_r2.entry.product.code]);
  }
}
const _c12 = a0 => ({
  code: a0
});
const _c13 = a0 => ({
  isSaveForLater: false,
  optionalBtn: a0
});
function CartDetailsComponent_ng_container_0_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "cx-cart-validation-warnings");
    i0.ɵɵelementStart(2, "h2", 4);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "cx-promotions", 5)(6, "cx-cart-item-list", 6);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entries_r1 = i0.ɵɵnextContext().ngIf;
    const cart_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    const saveForLaterBtn_r4 = i0.ɵɵreference(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 6, "cartDetails.cartName", i0.ɵɵpureFunction1(11, _c12, cart_r2.code)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("promotions", (cart_r2.appliedOrderPromotions || i0.ɵɵpureFunction0(13, _c5)).concat(cart_r2.potentialOrderPromotions || i0.ɵɵpureFunction0(14, _c5)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("items", entries_r1)("cartIsLoading", !i0.ɵɵpipeBind1(7, 9, ctx_r2.cartLoaded$))("promotionLocation", ctx_r2.promotionLocation)("options", i0.ɵɵpureFunction1(15, _c13, saveForLaterBtn_r4));
  }
}
function CartDetailsComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CartDetailsComponent_ng_container_0_ng_container_1_div_1_Template, 8, 17, "div", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cart_r2 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", cart_r2.totalItems > 0);
  }
}
function CartDetailsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CartDetailsComponent_ng_container_0_ng_container_1_Template, 2, 1, "ng-container", 1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r2.entries$));
  }
}
function CartDetailsComponent_ng_template_2_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function CartDetailsComponent_ng_template_2_button_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_ir6 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.saveForLater(ctx_ir6.item));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_ir6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("disabled", ctx_ir6.loading);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "saveForLaterItems.saveForLater"), " ");
  }
}
function CartDetailsComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CartDetailsComponent_ng_template_2_button_0_Template, 3, 4, "button", 7);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.selectiveCartEnabled);
  }
}
const _c14 = () => ({
  cxRoute: "checkout"
});
function CartTotalsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-order-summary", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cart_r1 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("cart", cart_r1);
  }
}
const _c15 = a0 => ({
  isSaveForLater: true,
  optionalBtn: a0
});
function SaveForLaterComponent_ng_container_0_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 3);
  }
  if (rf & 2) {
    const data_r1 = ctx.ngIf;
    i0.ɵɵproperty("innerHTML", data_r1.content, i0.ɵɵsanitizeHtml);
  }
}
function SaveForLaterComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SaveForLaterComponent_ng_container_0_p_1_Template, 1, 1, "p", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r1.data$));
  }
}
function SaveForLaterComponent_ng_container_2_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "cx-cart-item-list", 7);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entries_r3 = i0.ɵɵnextContext().ngIf;
    const saveForLater_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    const moveToCartBtn_r5 = i0.ɵɵreference(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 6, "saveForLaterItems.itemTotal", i0.ɵɵpureFunction1(11, _c4, saveForLater_r4.totalItems)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("items", entries_r3)("readonly", false)("cartIsLoading", !i0.ɵɵpipeBind1(5, 9, ctx_r1.cartLoaded$))("promotionLocation", ctx_r1.CartLocation.SaveForLater)("options", i0.ɵɵpureFunction1(13, _c15, moveToCartBtn_r5));
  }
}
function SaveForLaterComponent_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SaveForLaterComponent_ng_container_2_ng_container_1_div_1_Template, 6, 15, "div", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const saveForLater_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", saveForLater_r4.totalItems > 0);
  }
}
function SaveForLaterComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SaveForLaterComponent_ng_container_2_ng_container_1_Template, 2, 1, "ng-container", 1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r1.entries$));
  }
}
function SaveForLaterComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function SaveForLaterComponent_ng_template_4_Template_button_click_0_listener() {
      const ctx_ir7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.moveToCart(ctx_ir7.item));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_ir7 = ctx.$implicit;
    i0.ɵɵproperty("disabled", ctx_ir7.loading);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "saveForLaterItems.moveToCart"), " ");
  }
}
class AbstractOrderContextSource {
  constructor() {
    this.key$ = new ReplaySubject(1);
  }
  static {
    this.ɵfac = function AbstractOrderContextSource_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AbstractOrderContextSource)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AbstractOrderContextSource,
      factory: AbstractOrderContextSource.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AbstractOrderContextSource, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Context for transporting information about an abstract order (active cart, saved cart, order, quote).
 */
class AbstractOrderContext {
  static {
    this.ɵfac = function AbstractOrderContext_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AbstractOrderContext)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AbstractOrderContext,
      factory: AbstractOrderContext.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AbstractOrderContext, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AbstractOrderContextDirective {
  constructor() {
    this.abstractOrderContextSource = inject(AbstractOrderContextSource);
  }
  ngOnChanges(changes) {
    const contextChanges = changes.cxAbstractOrderContext;
    if (contextChanges) {
      let abstractOrderKey;
      const type = contextChanges.currentValue.type;
      if (type === AbstractOrderType.CART) {
        abstractOrderKey = {
          type
        };
      } else {
        const id = contextChanges.currentValue.id;
        if (id) {
          abstractOrderKey = {
            type,
            id
          };
        } else {
          throw new Error('id required for order, quote or saved cart');
        }
      }
      this.abstractOrderContextSource.key$.next(abstractOrderKey);
    }
  }
  static {
    this.ɵfac = function AbstractOrderContextDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AbstractOrderContextDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AbstractOrderContextDirective,
      selectors: [["", "cxAbstractOrderContext", ""]],
      inputs: {
        cxAbstractOrderContext: "cxAbstractOrderContext"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([AbstractOrderContextSource, {
        provide: AbstractOrderContext,
        useExisting: AbstractOrderContextSource
      }]), i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AbstractOrderContextDirective, [{
    type: Directive,
    args: [{
      selector: '[cxAbstractOrderContext]',
      providers: [AbstractOrderContextSource, {
        provide: AbstractOrderContext,
        useExisting: AbstractOrderContextSource
      }],
      standalone: false
    }]
  }], null, {
    cxAbstractOrderContext: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AbstractOrderContextModule {
  static {
    this.ɵfac = function AbstractOrderContextModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AbstractOrderContextModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AbstractOrderContextModule,
      declarations: [AbstractOrderContextDirective],
      exports: [AbstractOrderContextDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AbstractOrderContextModule, [{
    type: NgModule,
    args: [{
      declarations: [AbstractOrderContextDirective],
      exports: [AbstractOrderContextDirective]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddedToCartDialogEventListener {
  constructor(eventService, launchDialogService) {
    this.eventService = eventService;
    this.launchDialogService = launchDialogService;
    this.subscription = new Subscription();
    this.onAddToCart();
  }
  onAddToCart() {
    this.subscription.add(this.eventService.get(CartUiEventAddToCart).subscribe(event => {
      this.openModal(event);
    }));
    this.subscription.add(this.eventService.get(CartAddEntryFailEvent).subscribe(event => {
      this.closeModal(event);
    }));
  }
  /**
   * Opens modal based on CartUiEventAddToCart.
   * @param event Signals that a product has been added to the cart.
   */
  openModal(event) {
    const addToCartData = {
      productCode: event.productCode,
      quantity: event.quantity,
      numberOfEntriesBeforeAdd: event.numberOfEntriesBeforeAdd,
      pickupStoreName: event.pickupStoreName,
      addingEntryResult$: this.createCompletionObservable()
    };
    const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.ADDED_TO_CART, event?.triggerElementRef, undefined, addToCartData);
    if (dialog) {
      dialog.pipe(take(1)).subscribe();
    }
  }
  createCompletionObservable() {
    // We subscribe early to result events using ReplaySubject(1)
    // to ensure no missed emissions even if the modal subscribes late.
    const addingEntryResult$ = new ReplaySubject(1);
    race([this.eventService.get(CartAddEntrySuccessEvent), this.eventService.get(CartAddEntryFailEvent)]).subscribe(completionEvent => addingEntryResult$.next(completionEvent));
    return addingEntryResult$;
  }
  closeModal(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  static {
    this.ɵfac = function AddedToCartDialogEventListener_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddedToCartDialogEventListener)(i0.ɵɵinject(i2.EventService), i0.ɵɵinject(i2$1.LaunchDialogService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddedToCartDialogEventListener,
      factory: AddedToCartDialogEventListener.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddedToCartDialogEventListener, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i2.EventService
  }, {
    type: i2$1.LaunchDialogService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Context source for `CartItemComponent`.
 *
 * `CartItemContext` should be injected instead in child components.
 */
class CartItemContextSource {
  constructor() {
    this.compact$ = new ReplaySubject(1);
    this.readonly$ = new ReplaySubject(1);
    this.item$ = new ReplaySubject(1);
    this.quantityControl$ = new ReplaySubject(1);
    this.location$ = new ReplaySubject(1);
    this.options$ = new ReplaySubject(1);
  }
  static {
    this.ɵfac = function CartItemContextSource_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartItemContextSource)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CartItemContextSource,
      factory: CartItemContextSource.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartItemContextSource, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartItemValidationWarningComponent {
  constructor(cartValidationFacade) {
    this.cartValidationFacade = cartValidationFacade;
    this.iconTypes = ICON_TYPE;
    this.isVisible = true;
    this.cartModification$ = this.cartValidationFacade.getValidationResults().pipe(map(modificationList => modificationList.find(modification => modification.entry?.product?.code === this.code)));
  }
  static {
    this.ɵfac = function CartItemValidationWarningComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartItemValidationWarningComponent)(i0.ɵɵdirectiveInject(i1.CartValidationFacade));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CartItemValidationWarningComponent,
      selectors: [["cx-cart-item-validation-warning"]],
      inputs: {
        code: "code"
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], ["class", "alert alert-info", 4, "ngIf"], [1, "alert", "alert-info"], [1, "alert-icon"], [3, "type"], ["type", "button", 1, "close", 3, "click", "title"]],
      template: function CartItemValidationWarningComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CartItemValidationWarningComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.cartModification$));
        }
      },
      dependencies: [i4.NgIf, i2$1.IconComponent, i4.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartItemValidationWarningComponent, [{
    type: Component,
    args: [{
      selector: 'cx-cart-item-validation-warning',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"cartModification$ | async as cartModification\">\n  <div class=\"alert alert-info\" *ngIf=\"isVisible\">\n    <span class=\"alert-icon\">\n      <cx-icon [type]=\"iconTypes.INFO\"></cx-icon>\n    </span>\n    <span>\n      {{\n        'validation.' + cartModification.statusCode\n          | cxTranslate\n            : {\n                quantity: cartModification.quantityAdded,\n              }\n      }}\n    </span>\n\n    <button\n      class=\"close\"\n      type=\"button\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (click)=\"isVisible = !isVisible\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.CartValidationFacade
  }], {
    code: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartItemComponent {
  constructor(cartItemContextSource) {
    this.cartItemContextSource = cartItemContextSource;
    this.compact = false;
    this.readonly = false;
    this.promotionLocation = PromotionLocation.ActiveCart;
    // TODO: evaluate whether this is generic enough
    this.options = {
      isSaveForLater: false,
      optionalBtn: null,
      displayAddToCart: false
    };
    this.iconTypes = ICON_TYPE;
    this.CartOutlets = CartOutlets;
    useFeatureStyles('a11yQTY2Quantity');
    useFeatureStyles('a11yCroppedFocusRing');
  }
  ngOnChanges(changes) {
    if (changes?.compact) {
      this.cartItemContextSource.compact$.next(this.compact);
    }
    if (changes?.readonly) {
      this.cartItemContextSource.readonly$.next(this.readonly);
    }
    if (changes?.item) {
      this.cartItemContextSource.item$.next(this.item);
    }
    if (changes?.quantityControl) {
      this.cartItemContextSource.quantityControl$.next(this.quantityControl);
    }
    if (changes?.promotionLocation) {
      this.cartItemContextSource.location$.next(this.promotionLocation);
    }
    if (changes?.options) {
      this.cartItemContextSource.options$.next(this.options);
    }
  }
  isProductOutOfStock(product) {
    // TODO Move stocklevelstatuses across the app to an enum
    return product && product.stock && product.stock.stockLevelStatus === 'outOfStock';
  }
  removeItem() {
    this.quantityControl.setValue(0);
    this.quantityControl.markAsDirty();
  }
  static {
    this.ɵfac = function CartItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartItemComponent)(i0.ɵɵdirectiveInject(CartItemContextSource));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CartItemComponent,
      selectors: [["cx-cart-item"]],
      inputs: {
        compact: "compact",
        item: "item",
        readonly: "readonly",
        quantityControl: "quantityControl",
        promotionLocation: "promotionLocation",
        options: "options"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([CartItemContextSource, {
        provide: CartItemContext,
        useExisting: CartItemContextSource
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 1,
      vars: 1,
      consts: [["total", ""], ["forceInstock", ""], [3, "cxOutlet"], [3, "code"], [3, "ngClass"], [1, "col-2", "cx-image-container"], ["tabindex", "0", 3, "routerLink"], ["format", "cartIcon", 3, "container"], [1, "cx-info", "col-10"], [1, "cx-info-container", "row"], ["class", "cx-name", 4, "ngIf"], ["class", "cx-code", 4, "ngIf"], [4, "ngIf"], ["class", "cx-price", 3, "ngClass", 4, "ngIf"], [1, "cx-quantity", 3, "ngClass"], ["class", "cx-label", "placement", "left", 3, "ngClass", "title", 4, "cxFeature"], [1, "cx-value"], [3, "control", "readonly", "max", "allowZero"], [4, "ngIf", "ngIfElse"], ["class", "cx-availability col-12", 4, "ngIf"], [3, "promotions"], ["class", "cx-actions col-12", 4, "ngIf"], [1, "cx-name"], [1, "cx-link", 3, "routerLink"], [1, "cx-code"], ["class", "cx-property", 4, "ngFor", "ngForOf"], [1, "cx-property"], ["class", "cx-label", 4, "ngIf"], [1, "cx-label"], [1, "cx-price", 3, "ngClass"], [1, "cx-label", 3, "ngClass"], ["class", "cx-value", 4, "ngIf"], ["placement", "left", 1, "cx-label", 3, "ngClass", "title"], [1, "cx-total", 3, "ngClass"], ["class", "cx-value", 4, "ngIf", "ngIfElse"], [1, "cx-availability", "col-12"], [1, "cx-actions", "col-12"], [1, "col-md-3", "cx-remove-btn"], [1, "btn", "btn-tertiary", 3, "click", "cxAtMessage", "disabled"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "cx-total", 3, "ngClass", 4, "ngIf"]],
      template: function CartItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CartItemComponent_ng_template_0_Template, 27, 30, "ng-template", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxOutlet", ctx.CartOutlets.ITEM);
        }
      },
      dependencies: [i2$1.AtMessageDirective, CartItemValidationWarningComponent, i4.NgClass, i4.NgForOf, i4.NgIf, i4.NgTemplateOutlet, i2$1.ItemCounterComponent, i2$1.MediaComponent, i2$1.OutletDirective, i2$1.PromotionsComponent, i1$1.RouterLink, i2.FeatureDirective, i2.TranslatePipe, i2.UrlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartItemComponent, [{
    type: Component,
    args: [{
      selector: 'cx-cart-item',
      providers: [CartItemContextSource, {
        provide: CartItemContext,
        useExisting: CartItemContextSource
      }],
      standalone: false,
      template: "<!-- Item Start Outlet -->\n<ng-template [cxOutlet]=\"CartOutlets.ITEM\">\n  <ng-template [cxOutlet]=\"CartOutlets.ITEM_CONFIGURATOR_ISSUES\"></ng-template>\n  <cx-cart-item-validation-warning\n    [code]=\"item.product?.code\"\n  ></cx-cart-item-validation-warning>\n  <div [ngClass]=\"compact ? 'cx-compact row' : 'row'\">\n    <!-- Item Image -->\n    <div class=\"col-2 cx-image-container\">\n      <a\n        [routerLink]=\"{ cxRoute: 'product', params: item.product } | cxUrl\"\n        tabindex=\"0\"\n      >\n        <cx-media\n          [container]=\"item.product?.images?.PRIMARY\"\n          format=\"cartIcon\"\n        ></cx-media>\n      </a>\n    </div>\n    <!-- Item Information -->\n    <div class=\"cx-info col-10\">\n      <div class=\"cx-info-container row\">\n        <!-- Item Description -->\n        <div [ngClass]=\"compact ? '' : ' col-md-3 col-lg-3 col-xl-5'\">\n          <div *ngIf=\"item.product?.name\" class=\"cx-name\">\n            <a\n              class=\"cx-link\"\n              [routerLink]=\"\n                { cxRoute: 'product', params: item.product } | cxUrl\n              \"\n              ><h3>{{ item.product?.name }}</h3></a\n            >\n          </div>\n          <div *ngIf=\"item.product?.code\" class=\"cx-code\">\n            {{ 'cartItems.id' | cxTranslate }} {{ item.product?.code }}\n          </div>\n\n          <!-- Item Details Outlet -->\n          <ng-template [cxOutlet]=\"CartOutlets.ITEM_DETAILS\"> </ng-template>\n\n          <!-- Variants -->\n          <ng-container *ngIf=\"item.product?.baseOptions?.length\">\n            <div\n              *ngFor=\"\n                let variant of item.product?.baseOptions[0]?.selected\n                  ?.variantOptionQualifiers\n              \"\n              class=\"cx-property\"\n            >\n              <div class=\"cx-label\" *ngIf=\"variant.name && variant.value\">\n                {{ variant.name }}: {{ variant.value }}\n              </div>\n            </div>\n          </ng-container>\n        </div>\n        <!-- Item Price -->\n        <div\n          *ngIf=\"item.basePrice\"\n          class=\"cx-price\"\n          [ngClass]=\"compact ? '' : ' col-md-3 col-lg-3 col-xl-2'\"\n        >\n          <div\n            class=\"cx-label\"\n            [ngClass]=\"compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'\"\n          >\n            {{ 'cartItems.itemPrice' | cxTranslate }}\n          </div>\n          <div *ngIf=\"item.basePrice\" class=\"cx-value\">\n            {{ item.basePrice?.formattedValue }}\n          </div>\n        </div>\n        <!-- Item Quantity -->\n        <div class=\"cx-quantity\" [ngClass]=\"compact ? '' : ' col-3'\">\n          <div\n            *cxFeature=\"'a11yQTY2Quantity'\"\n            class=\"cx-label\"\n            [ngClass]=\"compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'\"\n            placement=\"left\"\n            title=\"{{ 'cartItems.quantityTitle' | cxTranslate }}\"\n          >\n            {{ 'cartItems.quantityFull' | cxTranslate }}\n          </div>\n          <div\n            *cxFeature=\"'!a11yQTY2Quantity'\"\n            class=\"cx-label\"\n            [ngClass]=\"compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'\"\n            placement=\"left\"\n            title=\"{{ 'cartItems.quantityTitle' | cxTranslate }}\"\n          >\n            {{ 'cartItems.quantity' | cxTranslate }}\n          </div>\n          <div class=\"cx-value\" [class.readonly-value]=\"readonly\">\n            <cx-item-counter\n              [control]=\"quantityControl\"\n              [readonly]=\"\n                !item.updateable || readonly || options.isSaveForLater\n              \"\n              [max]=\"item.product?.stock?.stockLevel\"\n              [allowZero]=\"true\"\n            >\n            </cx-item-counter>\n          </div>\n        </div>\n        <!-- Total -->\n        <ng-container *ngIf=\"options.isSaveForLater; else total\">\n          <div\n            class=\"cx-total\"\n            [ngClass]=\"compact ? '' : ' col-md-3 col-lg-3 col-xl-2'\"\n          >\n            <div\n              class=\"cx-label\"\n              [ngClass]=\"\n                compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'\n              \"\n            >\n              {{ 'saveForLaterItems.stock' | cxTranslate }}\n            </div>\n            <div\n              *ngIf=\"item.product?.stock.stockLevel >= 0; else forceInstock\"\n              class=\"cx-value\"\n            >\n              {{ item.product?.stock?.stockLevel }}\n            </div>\n            <ng-template #forceInstock>\n              <div class=\"cx-value\">\n                {{ 'saveForLaterItems.forceInStock' | cxTranslate }}\n              </div>\n            </ng-template>\n          </div>\n        </ng-container>\n      </div>\n      <!-- Availability -->\n      <div\n        *ngIf=\"isProductOutOfStock(item.product)\"\n        class=\"cx-availability col-12\"\n      >\n        {{ 'addToCart.outOfStock' | cxTranslate }}\n      </div>\n\n      <!-- Item Bundle Details Outlet -->\n      <ng-template [cxOutlet]=\"CartOutlets.ITEM_BUNDLE_DETAILS\"> </ng-template>\n\n      <!-- Promotion -->\n\n      <cx-promotions [promotions]=\"item.promotions\"></cx-promotions>\n\n      <!-- Actions -->\n      <div\n        *ngIf=\"(!readonly || options.isSaveForLater) && item.updateable\"\n        class=\"cx-actions col-12\"\n      >\n        <ng-container *ngIf=\"!isProductOutOfStock(item.product)\">\n          <ng-container\n            *ngTemplateOutlet=\"\n              options.optionalBtn;\n              context: {\n                $implicit: { loading: quantityControl.disabled, item: item },\n              }\n            \"\n          ></ng-container>\n        </ng-container>\n\n        <div class=\"col-md-3 cx-remove-btn\">\n          <button\n            (click)=\"removeItem()\"\n            [cxAtMessage]=\"'cartItems.itemRemoved' | cxTranslate\"\n            [disabled]=\"quantityControl.disabled\"\n            attr.aria-label=\"{{ 'addToCart.removeFromCart' | cxTranslate }}\"\n            class=\"btn btn-tertiary\"\n          >\n            {{ 'common.remove' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <ng-template #total>\n    <div\n      *ngIf=\"item.totalPrice\"\n      class=\"cx-total\"\n      [ngClass]=\"compact ? '' : ' col-md-3 col-xl-2'\"\n    >\n      <div\n        class=\"cx-label\"\n        [ngClass]=\"compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'\"\n      >\n        {{ 'cartItems.total' | cxTranslate }}\n      </div>\n      <div class=\"cx-value\">{{ item.totalPrice.formattedValue }}</div>\n    </div>\n  </ng-template>\n</ng-template>\n"
    }]
  }], () => [{
    type: CartItemContextSource
  }], {
    compact: [{
      type: Input
    }],
    item: [{
      type: Input
    }],
    readonly: [{
      type: Input
    }],
    quantityControl: [{
      type: Input
    }],
    promotionLocation: [{
      type: Input
    }],
    options: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddedToCartDialogComponent {
  handleClick(event) {
    if (event.target.tagName === this.el.nativeElement.tagName) {
      this.dismissModal('Cross click');
    }
  }
  constructor(activeCartFacade, launchDialogService, routingService, el) {
    this.activeCartFacade = activeCartFacade;
    this.launchDialogService = launchDialogService;
    this.routingService = routingService;
    this.el = el;
    this.iconTypes = ICON_TYPE;
    this.cart$ = this.activeCartFacade.getActive();
    this.loaded$ = this.activeCartFacade.isStable();
    this.promotionLocation = PromotionLocation.ActiveCart;
    this.quantity = 0;
    this.form = new UntypedFormGroup({});
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: 'button',
      focusOnEscape: true
    };
    this.subscription = new Subscription();
    useFeatureStyles('a11yPreventHorizontalScroll');
    useFeatureStyles('a11yUpdatingCartNoNarration');
  }
  ngOnInit() {
    this.subscription.add(this.launchDialogService.data$.subscribe(dialogData => {
      this.init(dialogData.productCode, dialogData.quantity, dialogData.numberOfEntriesBeforeAdd, dialogData.pickupStoreName, dialogData.addingEntryResult$);
    }));
    this.subscription.add(this.routingService.getRouterState().pipe(filter(state => !!state.nextState)).subscribe(() => this.dismissModal('dismiss')));
  }
  /**
   * Returns an observable formControl with the quantity of the cartEntry,
   * but also updates the entry in case of a changed value.
   * The quantity can be set to zero in order to remove the entry.
   */
  getQuantityControl() {
    if (!this.quantityControl$) {
      this.quantityControl$ = this.entry$.pipe(filter(e => !!e), map(entry => this.getQuantityFormControl(entry)), switchMap(() => this.form.valueChanges.pipe(
      // eslint-disable-next-line import/no-deprecated
      startWith(null), tap(valueChange => {
        if (valueChange) {
          this.activeCartFacade.updateEntry(valueChange.entryNumber, valueChange.quantity);
          if (valueChange.quantity === 0) {
            this.dismissModal('Removed');
          }
        } else {
          this.form.markAsPristine();
        }
      }))), map(() => this.form.get('quantity')), shareReplay({
        bufferSize: 1,
        refCount: true
      }));
    }
    return this.quantityControl$;
  }
  init(productCode, quantity, numberOfEntriesBeforeAdd, pickupStoreName, addingEntryResult$) {
    // Display last entry for new product code. This always corresponds to
    // our new item, independently of whether merging occured or not
    const productCode$ = addingEntryResult$ ?
    // get the product code from the backend response, because it might be different
    // from the requested product code. That can e.g. happen for certain kinds of product variants
    addingEntryResult$.pipe(filter(event => event instanceof CartAddEntrySuccessEvent), map(event => {
      const productCodeFromEntry = event.entry?.product?.code;
      return productCodeFromEntry ? productCodeFromEntry : event.productCode;
    })) : of(productCode);
    this.entry$ = productCode$.pipe(switchMap(code => this.activeCartFacade.getLastEntry(code)));
    this.quantity = quantity;
    this.pickupStoreName = pickupStoreName;
    this.addedEntryWasMerged$ = this.getAddedEntryWasMerged(numberOfEntriesBeforeAdd);
  }
  /**
   * Determines if the added entry was merged with an existing one.
   *
   * @param numberOfEntriesBeforeAdd Number of entries in cart before addToCart has been performed
   * @returns Has entry been merged?
   */
  getAddedEntryWasMerged(numberOfEntriesBeforeAdd) {
    return this.loaded$.pipe(filter(loaded => loaded), switchMap(() => this.activeCartFacade.getEntries()), map(entries => entries.length === numberOfEntriesBeforeAdd));
  }
  /**
   * Adds quantity and entryNumber form controls to the FormGroup.
   * Returns quantity form control.
   */
  getQuantityFormControl(entry) {
    if (!this.form.get('quantity')) {
      const quantity = new UntypedFormControl(entry?.quantity, {
        updateOn: 'blur'
      });
      this.form.addControl('quantity', quantity);
      const entryNumber = new UntypedFormControl(entry?.entryNumber);
      this.form.addControl('entryNumber', entryNumber);
    } else {
      // set the real quantity added to cart
      this.form.get('quantity')?.setValue(entry?.quantity);
    }
    return this.form.get('quantity');
  }
  dismissModal(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  onAction(action) {
    const actionDetails = {
      viewCart: {
        reason: 'View Cart click',
        cxRoute: 'cart'
      },
      checkout: {
        reason: 'Proceed To Checkout click',
        cxRoute: 'checkout'
      }
    };
    const {
      reason,
      cxRoute
    } = actionDetails[action];
    this.routingService.go({
      cxRoute
    });
    this.dismissModal(reason);
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  static {
    this.ɵfac = function AddedToCartDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddedToCartDialogComponent)(i0.ɵɵdirectiveInject(i1.ActiveCartFacade), i0.ɵɵdirectiveInject(i2$1.LaunchDialogService), i0.ɵɵdirectiveInject(i2.RoutingService), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AddedToCartDialogComponent,
      selectors: [["cx-added-to-cart-dialog"]],
      hostBindings: function AddedToCartDialogComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function AddedToCartDialogComponent_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
      },
      standalone: false,
      decls: 2,
      vars: 2,
      consts: [["loading", ""], ["class", "cx-modal-container", "role", "dialog", "aria-labelledby", "dialogTitle", 3, "cxFocus", "esc", 4, "cxFeature"], ["role", "dialog", "aria-labelledby", "dialogTitle", 1, "cx-modal-container", 3, "esc", "cxFocus"], [1, "cx-modal-content"], ["aria-live", "polite", "aria-atomic", "true", 1, "cx-dialog-header", "modal-header"], ["id", "dialogTitle", "class", "cx-dialog-title modal-title", "role", "none", 4, "cxFeature"], ["id", "dialogTitle", "class", "cx-dialog-title modal-title", 4, "cxFeature"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], [4, "ngIf", "ngIfElse"], ["id", "dialogTitle", "role", "none", 1, "cx-dialog-title", "modal-title"], ["id", "dialogTitle", 1, "cx-dialog-title", "modal-title"], ["class", "cx-dialog-body modal-body", 4, "ngIf"], [1, "cx-dialog-body", "modal-body"], [1, "cx-dialog-row"], [1, "cx-dialog-item", "col-sm-12", "col-md-6"], [3, "item", "compact", "quantityControl", "promotionLocation"], ["class", "cx-dialog-pickup-store", 4, "ngIf"], [1, "cx-dialog-separator", "col-sm-12", "d-xs-block", "d-sm-block", "d-md-none"], ["class", "cx-dialog-actions col-sm-12 col-md-6", 4, "ngIf"], [1, "cx-dialog-pickup-store"], [1, "cx-dialog-pickup-store-name"], [1, "cx-dialog-actions", "col-sm-12", "col-md-6"], [1, "cx-dialog-total"], [1, "cx-dialog-promotions"], [3, "promotions"], [1, "cx-dialog-buttons"], ["autofocus", "", 1, "btn", "btn-primary", 3, "click"], [1, "btn", "btn-secondary", 3, "click"], [1, "col-sm-12"], ["aria-live", "polite", "aria-atomic", "true", 1, "cx-visually-hidden"], [1, "cx-dialog-header", "modal-header"], ["class", "cx-dialog-title modal-title", 4, "cxFeature"], [1, "cx-dialog-title", "modal-title"]],
      template: function AddedToCartDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, AddedToCartDialogComponent_div_0_Template, 14, 14, "div", 1)(1, AddedToCartDialogComponent_div_1_Template, 11, 12, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFeature", "a11yAddedToCartActiveDialog");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!a11yAddedToCartActiveDialog");
        }
      },
      dependencies: [i4.NgIf, CartItemComponent, i2$1.SpinnerComponent, i2$1.PromotionsComponent, i2$1.IconComponent, i2$1.FocusDirective, i2.FeatureDirective, i4.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddedToCartDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-added-to-cart-dialog',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  *cxFeature=\"'a11yAddedToCartActiveDialog'\"\n  class=\"cx-modal-container\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"dismissModal('Escape pressed')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"cx-modal-content\">\n    <!-- Modal Header -->\n    <div\n      aria-live=\"polite\"\n      aria-atomic=\"true\"\n      class=\"cx-dialog-header modal-header\"\n    >\n      <div\n        *cxFeature=\"'a11yUpdatingCartNoNarration'\"\n        id=\"dialogTitle\"\n        class=\"cx-dialog-title modal-title\"\n        role=\"none\"\n      >\n        {{ 'addToCart.itemAddedToYourCart' | cxTranslate }}\n      </div>\n      <div\n        *cxFeature=\"'!a11yUpdatingCartNoNarration'\"\n        id=\"dialogTitle\"\n        class=\"cx-dialog-title modal-title\"\n      >\n        {{\n          (loaded$ | async)\n            ? (addedEntryWasMerged$ | async)\n              ? ('addToCart.itemsIncrementedInYourCart' | cxTranslate)\n              : ('addToCart.itemsAddedToYourCart' | cxTranslate)\n            : ('addToCart.updatingCart' | cxTranslate)\n        }}\n      </div>\n      <button\n        type=\"button\"\n        class=\"close\"\n        title=\"{{ 'common.close' | cxTranslate }}\"\n        attr.aria-label=\"{{ 'addToCart.closeModal' | cxTranslate }}\"\n        (click)=\"dismissModal('Cross click')\"\n      >\n        <span aria-hidden=\"true\">\n          <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n        </span>\n      </button>\n    </div>\n\n    <!-- Modal Body -->\n    <ng-container *ngIf=\"loaded$ | async; else loading\">\n      <div class=\"cx-dialog-body modal-body\" *ngIf=\"entry$ | async as entry\">\n        <div class=\"cx-dialog-row\">\n          <div class=\"cx-dialog-item col-sm-12 col-md-6\">\n            <cx-cart-item\n              [item]=\"entry\"\n              [compact]=\"true\"\n              [quantityControl]=\"getQuantityControl() | async\"\n              [promotionLocation]=\"promotionLocation\"\n            ></cx-cart-item>\n            <div class=\"cx-dialog-pickup-store\" *ngIf=\"pickupStoreName\">\n              {{ 'pickupOptionDialog.modalHeader' | cxTranslate }}:\n              <span class=\"cx-dialog-pickup-store-name\">{{\n                pickupStoreName\n              }}</span>\n            </div>\n          </div>\n          <!-- Separator -->\n          <div\n            class=\"cx-dialog-separator col-sm-12 d-xs-block d-sm-block d-md-none\"\n          ></div>\n          <!-- Total container -->\n          <div\n            class=\"cx-dialog-actions col-sm-12 col-md-6\"\n            *ngIf=\"cart$ | async as cart\"\n          >\n            <div class=\"cx-dialog-total\">\n              <div>\n                {{\n                  'cartItems.cartTotal'\n                    | cxTranslate: { count: cart.totalUnitCount }\n                }}\n              </div>\n\n              <div>{{ cart.subTotal?.formattedValue }}</div>\n            </div>\n\n            <!-- Promotions -->\n            <div class=\"cx-dialog-promotions\">\n              <cx-promotions\n                [promotions]=\"\n                  (cart.appliedOrderPromotions || []).concat(\n                    cart.potentialOrderPromotions || []\n                  )\n                \"\n              ></cx-promotions>\n            </div>\n\n            <!-- Actions -->\n            <div class=\"cx-dialog-buttons\">\n              <button\n                [class.disabled]=\"form.dirty\"\n                (click)=\"onAction('viewCart')\"\n                class=\"btn btn-primary\"\n                autofocus\n              >\n                {{ 'addToCart.viewCart' | cxTranslate }}\n              </button>\n              <button\n                [class.disabled]=\"form.dirty\"\n                (click)=\"onAction('checkout')\"\n                class=\"btn btn-secondary\"\n              >\n                {{ 'addToCart.proceedToCheckout' | cxTranslate }}\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n  </div>\n\n  <!-- Modal Body -->\n  <ng-template #loading>\n    <div class=\"cx-dialog-body modal-body\">\n      <div class=\"cx-dialog-row\">\n        <div class=\"col-sm-12\">\n          <cx-spinner aria-hidden=\"true\"></cx-spinner>\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</div>\n\n<div\n  *cxFeature=\"'!a11yAddedToCartActiveDialog'\"\n  class=\"cx-modal-container\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"dismissModal('Escape pressed')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"cx-modal-content\">\n    <!-- Modal Header -->\n    <ng-container *ngIf=\"loaded$ | async; else loading\">\n      <div class=\"cx-dialog-header modal-header\">\n        <h3\n          *cxFeature=\"'a11yDialogsHeading'\"\n          id=\"dialogTitle\"\n          class=\"cx-dialog-title modal-title\"\n        >\n          {{\n            (addedEntryWasMerged$ | async)\n              ? ('addToCart.itemsIncrementedInYourCart' | cxTranslate)\n              : ('addToCart.itemsAddedToYourCart' | cxTranslate)\n          }}\n        </h3>\n        <div\n          *cxFeature=\"'!a11yDialogsHeading'\"\n          id=\"dialogTitle\"\n          class=\"cx-dialog-title modal-title\"\n        >\n          {{\n            (addedEntryWasMerged$ | async)\n              ? ('addToCart.itemsIncrementedInYourCart' | cxTranslate)\n              : ('addToCart.itemsAddedToYourCart' | cxTranslate)\n          }}\n        </div>\n        <button\n          type=\"button\"\n          class=\"close\"\n          attr.aria-label=\"{{ 'addToCart.closeModal' | cxTranslate }}\"\n          title=\"{{ 'common.close' | cxTranslate }}\"\n          (click)=\"dismissModal('Cross click')\"\n        >\n          <span aria-hidden=\"true\">\n            <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n          </span>\n        </button>\n      </div>\n\n      <!-- Modal Body -->\n      <div class=\"cx-dialog-body modal-body\" *ngIf=\"entry$ | async as entry\">\n        <div class=\"cx-dialog-row\">\n          <div class=\"cx-dialog-item col-sm-12 col-md-6\">\n            <cx-cart-item\n              [item]=\"entry\"\n              [compact]=\"true\"\n              [quantityControl]=\"getQuantityControl() | async\"\n              [promotionLocation]=\"promotionLocation\"\n            ></cx-cart-item>\n            <div class=\"cx-dialog-pickup-store\" *ngIf=\"pickupStoreName\">\n              {{ 'pickupOptionDialog.modalHeader' | cxTranslate }}:\n              <span class=\"cx-dialog-pickup-store-name\">{{\n                pickupStoreName\n              }}</span>\n            </div>\n          </div>\n          <!-- Separator -->\n          <div\n            class=\"cx-dialog-separator col-sm-12 d-xs-block d-sm-block d-md-none\"\n          ></div>\n          <!-- Total container -->\n          <div\n            class=\"cx-dialog-actions col-sm-12 col-md-6\"\n            *ngIf=\"cart$ | async as cart\"\n          >\n            <div class=\"cx-dialog-total\">\n              <div>\n                {{\n                  'cartItems.cartTotal'\n                    | cxTranslate: { count: cart.totalUnitCount }\n                }}\n              </div>\n\n              <div>{{ cart.subTotal?.formattedValue }}</div>\n            </div>\n\n            <!-- Promotions -->\n            <div class=\"cx-dialog-promotions\">\n              <cx-promotions\n                [promotions]=\"\n                  (cart.appliedOrderPromotions || []).concat(\n                    cart.potentialOrderPromotions || []\n                  )\n                \"\n              ></cx-promotions>\n            </div>\n\n            <!-- Actions -->\n            <div class=\"cx-dialog-buttons\">\n              <button\n                [class.disabled]=\"form.dirty\"\n                (click)=\"onAction('viewCart')\"\n                class=\"btn btn-primary\"\n                autofocus\n              >\n                {{ 'addToCart.viewCart' | cxTranslate }}\n              </button>\n              <button\n                [class.disabled]=\"form.dirty\"\n                (click)=\"onAction('checkout')\"\n                class=\"btn btn-secondary\"\n              >\n                {{ 'addToCart.proceedToCheckout' | cxTranslate }}\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n\n    <ng-template #loading>\n      <div class=\"cx-dialog-header modal-header\">\n        <h2\n          *cxFeature=\"'a11yDialogsHeading'\"\n          class=\"cx-dialog-title modal-title\"\n        >\n          {{ 'addToCart.updatingCart' | cxTranslate }}\n        </h2>\n        <div\n          *cxFeature=\"'!a11yDialogsHeading'\"\n          class=\"cx-dialog-title modal-title\"\n        >\n          {{ 'addToCart.updatingCart' | cxTranslate }}\n        </div>\n        <button\n          type=\"button\"\n          class=\"close\"\n          title=\"{{ 'common.close' | cxTranslate }}\"\n          [attr.aria-label]=\"'common.close' | cxTranslate\"\n          (click)=\"dismissModal('Cross click')\"\n        >\n          <span aria-hidden=\"true\">\n            <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n          </span>\n        </button>\n      </div>\n      <!-- Modal Body -->\n      <div class=\"cx-dialog-body modal-body\">\n        <div class=\"cx-dialog-row\">\n          <div class=\"col-sm-12\"><cx-spinner></cx-spinner></div>\n        </div>\n      </div>\n    </ng-template>\n\n    <!-- For screen reader purposes (not visual)-->\n    <div class=\"cx-visually-hidden\" aria-live=\"polite\" aria-atomic=\"true\">\n      {{\n        (addedEntryWasMerged$ | async)\n          ? ('addToCart.itemsIncrementedInYourCart' | cxTranslate)\n          : ('addToCart.itemsAddedToYourCart' | cxTranslate)\n      }}\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i1.ActiveCartFacade
  }, {
    type: i2$1.LaunchDialogService
  }, {
    type: i2.RoutingService
  }, {
    type: i0.ElementRef
  }], {
    handleClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddToCartComponent {
  /**
   * We disable the dialog launch on quantity input,
   * as it causes an unexpected change of context.
   * The expectation is only for the quantity to get updated in the Qty field.
   */
  handleKeyboardEvent(event) {
    const eventTarget = event.target;
    const isQuantityInput = eventTarget.ariaLabel === 'Quantity' && eventTarget.tagName === 'INPUT';
    if (event.key === 'Enter' && isQuantityInput) {
      event.preventDefault();
    }
  }
  constructor(currentProductService, cd, activeCartService, component, eventService, productListItemContext) {
    this.currentProductService = currentProductService;
    this.cd = cd;
    this.activeCartService = activeCartService;
    this.component = component;
    this.eventService = eventService;
    this.productListItemContext = productListItemContext;
    this.showQuantity = true;
    this.disabled = false;
    this.hasStock = false;
    this.inventoryThreshold = false;
    this.showInventory$ = this.component?.data$.pipe(map(data => data.inventoryDisplay));
    this.quantity = 1;
    this.subscription = new Subscription();
    this.addToCartForm = new UntypedFormGroup({
      quantity: new UntypedFormControl(1, {
        updateOn: 'blur'
      })
    });
    this.CartOutlets = CartOutlets;
    this.iconTypes = ICON_TYPE;
    this.featureConfigService = inject(FeatureConfigService);
    this.featureToggles = inject(FeatureToggles);
    this.productAvailabilityService = inject(ProductAvailabilityService);
    useFeatureStyles('a11yQTY2Quantity');
  }
  ngOnInit() {
    if (this.product) {
      this.productCode = this.product.code ?? '';
      this.setStockInfo(this.product);
    } else if (this.productCode) {
      // force hasStock and quantity for the time being, as we do not have more info:
      this.quantity = 1;
      this.hasStock = true;
      this.cd.markForCheck();
    } else {
      let product$;
      if (this.productListItemContext) {
        product$ = this.productListItemContext.product$;
      } else if (this.featureToggles.showRealTimeStockInPDP) {
        product$ = this.currentProductService.getProduct([ProductScope.UNIT, ProductScope.DETAILS]);
      } else {
        product$ = this.currentProductService.getProduct();
      }
      this.subscription.add(product$.pipe(filter(isNotNullable)).subscribe(product => {
        this.productCode = product.code ?? '';
        this.product = product;
        this.setStockInfo(product);
      }));
    }
  }
  setStockInfo(product) {
    this.quantity = 1;
    this.addToCartForm.controls['quantity'].setValue(1);
    this.inventoryThreshold = product.stock?.isValueRounded ?? false;
    if (this.productListItemContext) {
      this.showQuantity = false;
    }
    /**
     * When removing the feature toggle in the future, let's leave the if-else block.
     * In case of absent sapUnit we want to fallback to the stock info from the product object.
     */
    if (this.featureToggles.showRealTimeStockInPDP && product.sapUnit?.sapCode) {
      this.productAvailabilityService.getRealTimeStock(this.productCode, product.sapUnit?.sapCode).pipe(take(1)).subscribe(({
        quantity,
        status
      }) => {
        this.maxQuantity = Number(quantity);
        this.hasStock = Boolean(status && status !== 'OUT_OF_STOCK');
        this.cd.markForCheck();
      });
    } else {
      this.hasStock = Boolean(product.stock?.stockLevelStatus !== 'outOfStock');
      if (this.hasStock && product.stock?.stockLevel) {
        this.maxQuantity = product.stock.stockLevel;
      }
      this.cd.markForCheck();
    }
  }
  /**
   * In specific scenarios, we need to omit displaying the stock level or append a plus to the value.
   * When backoffice forces a product to be in stock, omit showing the stock level.
   * When product stock level is limited by a threshold value, append '+' at the end.
   * When out of stock, display no numerical value.
   */
  getInventory() {
    if (this.hasStock) {
      const quantityDisplay = this.maxQuantity ? this.maxQuantity.toString() : '';
      return this.inventoryThreshold ? quantityDisplay + '+' : quantityDisplay;
    } else {
      return '';
    }
  }
  updateCount(value) {
    this.quantity = value;
  }
  addToCart() {
    let quantity = 0;
    if (this.savedCart) {
      quantity = this.getQuantityFromSavedCart(this.productCode);
    } else {
      quantity = this.addToCartForm.get('quantity')?.value;
    }
    if (!this.productCode || quantity <= 0) {
      return;
    }
    if (this.pickupOptionCompRef instanceof ComponentRef) {
      this.pickupOptionCompRef.instance.intendedPickupLocation$.pipe(take(1)).subscribe(intendedPickupLocation => {
        this.pickupStore = intendedPickupLocation?.pickupOption === 'pickup' ? intendedPickupLocation.name : undefined;
      });
    }
    this.activeCartService.getEntries().pipe(take(1)).subscribe(cartEntries => {
      this.activeCartService.addEntry(this.productCode, quantity, this.pickupStore);
      // A CartUiEventAddToCart is dispatched.  This event is intended for the UI
      // responsible to provide feedback about what was added to the cart, like
      // the added to cart dialog.
      //
      // Because we call activeCartService.getEntries() before, we can be sure the
      // cart library is loaded already and that the event listener exists.
      this.eventService.dispatch(this.createCartUiEventAddToCart(this.productCode, quantity, cartEntries.length, this.pickupStore));
    });
  }
  createCartUiEventAddToCart(productCode, quantity, numberOfEntriesBeforeAdd, storeName) {
    const newEvent = new CartUiEventAddToCart();
    newEvent.productCode = productCode;
    newEvent.quantity = quantity;
    newEvent.numberOfEntriesBeforeAdd = numberOfEntriesBeforeAdd;
    newEvent.pickupStoreName = storeName;
    if (this.featureConfigService.isEnabled('a11yDialogTriggerRefocus')) {
      newEvent.triggerElementRef = this.addToCartDialogTriggerEl;
    }
    return newEvent;
  }
  onPickupOptionsCompLoaded() {
    if (this.featureConfigService.isEnabled('a11yPickupOptionsTabs') && this.pickupOptionCompRef instanceof ComponentRef) {
      this.subscription.add(this.pickupOptionCompRef.instance.intendedPickupChange.subscribe(intendedPickupLocation => {
        this.disabled = intendedPickupLocation?.pickupOption === 'pickup' && !intendedPickupLocation.displayName;
      }));
    }
  }
  getQuantityFromSavedCart(productCode) {
    return this.savedCart?.entries?.find(e => e?.product?.code === productCode)?.quantity ?? 0;
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function AddToCartComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddToCartComponent)(i0.ɵɵdirectiveInject(i2$1.CurrentProductService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.ActiveCartFacade), i0.ɵɵdirectiveInject(i2$1.CmsComponentData), i0.ɵɵdirectiveInject(i2.EventService), i0.ɵɵdirectiveInject(i2$1.ProductListItemContext, 8));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AddToCartComponent,
      selectors: [["cx-add-to-cart"]],
      viewQuery: function AddToCartComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c6, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addToCartDialogTriggerEl = _t.first);
        }
      },
      hostBindings: function AddToCartComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function AddToCartComponent_keydown_HostBindingHandler($event) {
            return ctx.handleKeyboardEvent($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        productCode: "productCode",
        showQuantity: "showQuantity",
        options: "options",
        pickupStore: "pickupStore",
        savedCart: "savedCart",
        product: "product"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["addToCartDialogTriggerEl", ""], [3, "formGroup", "submit", 4, "ngIf"], [3, "submit", "formGroup"], ["class", "quantity", 4, "ngIf"], [4, "ngIf"], ["type", "submit", 3, "ngClass", "disabled", 4, "ngIf"], [1, "quantity"], [4, "cxFeature"], [1, "cx-counter-stock"], [3, "max", "control", "ariaDescribedById", 4, "ngIf"], ["id", "add-to-card-stock-info", 1, "info"], [3, "max", "control", "ariaDescribedById"], [3, "cxComponentRefChange", "cxOutlet", "cxComponentRef"], ["type", "submit", 3, "ngClass", "disabled"], ["class", "repeat-icon", 4, "ngIf"], [3, "ngClass"], [1, "repeat-icon"], [3, "type"]],
      template: function AddToCartComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, AddToCartComponent_form_0_Template, 4, 4, "form", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.productCode);
        }
      },
      dependencies: [i4.NgClass, i4.NgIf, i2$2.ɵNgNoValidate, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i2$1.IconComponent, i2$1.ItemCounterComponent, i2$1.OutletDirective, i2.FeatureDirective, i4.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddToCartComponent, [{
    type: Component,
    args: [{
      selector: 'cx-add-to-cart',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<form *ngIf=\"productCode\" [formGroup]=\"addToCartForm\" (submit)=\"addToCart()\">\n  <div class=\"quantity\" *ngIf=\"showQuantity\">\n    <label *cxFeature=\"'a11yQTY2Quantity'\">{{\n      'addToCart.quantityFull' | cxTranslate\n    }}</label>\n    <label *cxFeature=\"'!a11yQTY2Quantity'\">{{\n      'addToCart.quantity' | cxTranslate\n    }}</label>\n    <div class=\"cx-counter-stock\">\n      <cx-item-counter\n        *ngIf=\"hasStock\"\n        [max]=\"maxQuantity\"\n        [control]=\"addToCartForm.get('quantity')\"\n        [ariaDescribedById]=\"'add-to-card-stock-info'\"\n      ></cx-item-counter>\n\n      <span class=\"info\" id=\"add-to-card-stock-info\">\n        <span *ngIf=\"showInventory$ | async\">{{ getInventory() }}</span>\n        {{\n          hasStock\n            ? ('addToCart.inStock' | cxTranslate)\n            : ('addToCart.outOfStock' | cxTranslate)\n        }}</span\n      >\n    </div>\n  </div>\n\n  <ng-container *ngIf=\"hasStock\">\n    <ng-template\n      [cxOutlet]=\"CartOutlets.ADD_TO_CART_PICKUP_OPTION\"\n      [(cxComponentRef)]=\"pickupOptionCompRef\"\n      (cxComponentRefChange)=\"onPickupOptionsCompLoaded()\"\n    ></ng-template>\n  </ng-container>\n\n  <button\n    #addToCartDialogTriggerEl\n    *ngIf=\"hasStock\"\n    [ngClass]=\"\n      options?.displayAddToCart\n        ? 'btn btn-tertiary'\n        : 'btn btn-primary btn-block'\n    \"\n    type=\"submit\"\n    [disabled]=\"disabled || quantity <= 0 || quantity > maxQuantity\"\n    [attr.aria-label]=\"\n      product?.name\n        ? ('addToCart.addToCart' | cxTranslate) + ', ' + product?.name\n        : ('addToCart.addToCart' | cxTranslate)\n    \"\n  >\n    <span\n      *ngIf=\"\n        options?.addToCartString === ('addToCart.buyItAgain' | cxTranslate)\n      \"\n      class=\"repeat-icon\"\n      ><cx-icon [type]=\"iconTypes.REPEAT\"></cx-icon\n    ></span>\n    <span\n      [ngClass]=\"\n        options?.addToCartString === ('addToCart.buyItAgain' | cxTranslate)\n          ? 'buyItAgainLink'\n          : ''\n      \"\n    >\n      {{ options?.addToCartString ?? ('addToCart.addToCart' | cxTranslate) }}\n    </span>\n  </button>\n</form>\n"
    }]
  }], () => [{
    type: i2$1.CurrentProductService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i1.ActiveCartFacade
  }, {
    type: i2$1.CmsComponentData
  }, {
    type: i2.EventService
  }, {
    type: i2$1.ProductListItemContext,
    decorators: [{
      type: Optional
    }]
  }], {
    productCode: [{
      type: Input
    }],
    showQuantity: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    pickupStore: [{
      type: Input
    }],
    savedCart: [{
      type: Input
    }],
    product: [{
      type: Input
    }],
    addToCartDialogTriggerEl: [{
      type: ViewChild,
      args: ['addToCartDialogTriggerEl']
    }],
    handleKeyboardEvent: [{
      type: HostListener,
      args: ['document:keydown', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddToCartModule {
  static {
    this.ɵfac = function AddToCartModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddToCartModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AddToCartModule,
      declarations: [AddToCartComponent],
      imports: [CommonModule, ReactiveFormsModule, I18nModule, IconModule, ItemCounterModule, OutletModule, FeaturesConfigModule],
      exports: [AddToCartComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductAddToCartComponent: {
            component: AddToCartComponent,
            data: {
              inventoryDisplay: false
            }
          }
        }
      })],
      imports: [CommonModule, ReactiveFormsModule, I18nModule, IconModule, ItemCounterModule, OutletModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddToCartModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, I18nModule, IconModule, ItemCounterModule, OutletModule, FeaturesConfigModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductAddToCartComponent: {
            component: AddToCartComponent,
            data: {
              inventoryDisplay: false
            }
          }
        }
      })],
      declarations: [AddToCartComponent],
      exports: [AddToCartComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AppliedCouponsComponent {
  constructor(cartVoucherService) {
    this.cartVoucherService = cartVoucherService;
    this.cartIsLoading = false;
    this.isReadOnly = false;
    this.iconTypes = ICON_TYPE;
  }
  get sortedVouchers() {
    this.vouchers = this.vouchers || [];
    return this.vouchers.slice().sort((a, b) => {
      return a.code && b.code ? a.code.localeCompare(b.code) : 0;
    });
  }
  removeVoucher(voucherId) {
    this.cartVoucherService.removeVoucher(voucherId);
  }
  static {
    this.ɵfac = function AppliedCouponsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AppliedCouponsComponent)(i0.ɵɵdirectiveInject(i1.CartVoucherFacade));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AppliedCouponsComponent,
      selectors: [["cx-applied-coupons"]],
      inputs: {
        vouchers: "vouchers",
        cartIsLoading: "cartIsLoading",
        isReadOnly: "isReadOnly"
      },
      standalone: false,
      decls: 3,
      vars: 2,
      consts: [["editableCoupons", ""], [4, "ngIf", "ngIfElse"], [4, "ngIf"], ["class", "coupon-summary cx-coupon-card textonly", 4, "ngFor", "ngForOf"], [1, "cx-applied-coupon-title"], [1, "coupon-summary", "cx-coupon-card", "textonly"], [1, "cx-applied-coupon-code"], [1, "row"], ["class", "col-sm-12 col-md-6 col-lg-12 cx-coupon-card-grid", 4, "ngFor", "ngForOf"], [1, "col-sm-12", "col-md-6", "col-lg-12", "cx-coupon-card-grid"], [1, "cx-coupon-apply", "cx-coupon-card", "cx-coupon-list-wrap"], [1, "cx-cart-coupon-code"], ["type", "button", 1, "close", 3, "click", "title", "disabled"], ["aria-hidden", "true"], [3, "type"]],
      template: function AppliedCouponsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, AppliedCouponsComponent_div_0_Template, 4, 2, "div", 1)(1, AppliedCouponsComponent_ng_template_1_Template, 3, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const editableCoupons_r5 = i0.ɵɵreference(2);
          i0.ɵɵproperty("ngIf", ctx.isReadOnly)("ngIfElse", editableCoupons_r5);
        }
      },
      dependencies: [i4.NgForOf, i4.NgIf, i2$1.IconComponent, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppliedCouponsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-applied-coupons',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div *ngIf=\"isReadOnly; else editableCoupons\">\n  <div *ngIf=\"sortedVouchers.length > 0\">\n    <div class=\"cx-applied-coupon-title\">\n      {{ 'voucher.vouchersApplied' | cxTranslate }}\n    </div>\n  </div>\n  <ng-container>\n    <div\n      *ngFor=\"let voucher of sortedVouchers\"\n      class=\"coupon-summary cx-coupon-card textonly\"\n    >\n      <span class=\"cx-applied-coupon-code\">{{ voucher.voucherCode }}</span>\n    </div>\n  </ng-container>\n</div>\n\n<ng-template #editableCoupons>\n  <div class=\"row\">\n    <ng-container>\n      <div\n        *ngFor=\"let voucher of sortedVouchers\"\n        class=\"col-sm-12 col-md-6 col-lg-12 cx-coupon-card-grid\"\n      >\n        <div class=\"cx-coupon-apply cx-coupon-card cx-coupon-list-wrap\">\n          <span class=\"cx-cart-coupon-code\">{{ voucher.voucherCode }}</span>\n          <button\n            type=\"button\"\n            class=\"close\"\n            title=\"{{ 'common.close' | cxTranslate }}\"\n            [attr.aria-label]=\"'common.close' | cxTranslate\"\n            (click)=\"removeVoucher(voucher.voucherCode)\"\n            [disabled]=\"cartIsLoading\"\n            [class.disabled]=\"cartIsLoading\"\n          >\n            <span aria-hidden=\"true\">\n              <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n            </span>\n          </button>\n        </div>\n      </div>\n    </ng-container>\n  </div>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1.CartVoucherFacade
  }], {
    vouchers: [{
      type: Input
    }],
    cartIsLoading: [{
      type: Input
    }],
    isReadOnly: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartCouponComponent {
  constructor(cartVoucherService, formBuilder, customerCouponService, activeCartService) {
    this.cartVoucherService = cartVoucherService;
    this.formBuilder = formBuilder;
    this.customerCouponService = customerCouponService;
    this.activeCartService = activeCartService;
    this.MAX_CUSTOMER_COUPON_PAGE = 100;
    this.ignoreCloseEvent = false;
    this.subscription = new Subscription();
    this.couponBoxIsActive = false;
    this.featureConfigService = inject(FeatureConfigService, {
      optional: true
    });
  }
  ngOnInit() {
    if (this.customerCouponService) {
      this.customerCouponService.loadCustomerCoupons(this.MAX_CUSTOMER_COUPON_PAGE);
    }
    this.cart$ = combineLatest([this.activeCartService.getActive(), this.activeCartService.getActiveCartId(), this.customerCouponService.getCustomerCoupons(this.MAX_CUSTOMER_COUPON_PAGE)]).pipe(tap(([cart, activeCardId, customerCoupons]) => {
      this.cartId = activeCardId;
      this.getApplicableCustomerCoupons(cart, customerCoupons.coupons ?? []);
    }), map(([cart]) => cart));
    this.cartIsLoading$ = this.activeCartService.isStable().pipe(map(loaded => !loaded));
    this.cartVoucherService.resetAddVoucherProcessingState();
    this.couponForm = this.formBuilder.group({
      couponCode: ['', [Validators.required]]
    });
    // TODO(#7241): Replace process subscriptions with event listeners and drop process for ADD_VOUCHER
    this.subscription.add(this.cartVoucherService.getAddVoucherResultSuccess().subscribe(success => {
      this.onSuccess(success);
    }));
    // TODO(#7241): Replace process subscriptions with event listeners and drop process for ADD_VOUCHER
    this.subscription.add(this.cartVoucherService.getAddVoucherResultError().subscribe(error => {
      this.onError(error);
    }));
  }
  onError(error) {
    if (error) {
      this.customerCouponService.loadCustomerCoupons(this.MAX_CUSTOMER_COUPON_PAGE);
      this.cartVoucherService.resetAddVoucherProcessingState();
    }
  }
  onSuccess(success) {
    if (success) {
      this.couponForm.reset();
      this.cartVoucherService.resetAddVoucherProcessingState();
    }
  }
  getApplicableCustomerCoupons(cart, coupons) {
    this.applicableCoupons = coupons || [];
    if (cart.appliedVouchers) {
      cart.appliedVouchers.forEach(appliedVoucher => {
        this.applicableCoupons = this.applicableCoupons.filter(coupon => coupon.couponId !== appliedVoucher.code);
      });
    }
  }
  applyVoucher() {
    if (this.couponForm.valid) {
      this.cartVoucherService.addVoucher(this.couponForm.value.couponCode, this.cartId);
    } else {
      this.couponForm.markAllAsTouched();
    }
  }
  applyCustomerCoupon(couponId) {
    this.cartVoucherService.addVoucher(couponId, this.cartId);
    this.couponBoxIsActive = false;
  }
  close(event) {
    if (!this.ignoreCloseEvent) {
      this.couponBoxIsActive = false;
      if (event && event.target) {
        event.target.blur();
      }
    }
    this.ignoreCloseEvent = false;
  }
  disableClose() {
    this.ignoreCloseEvent = true;
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.cartVoucherService.resetAddVoucherProcessingState();
  }
  static {
    this.ɵfac = function CartCouponComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartCouponComponent)(i0.ɵɵdirectiveInject(i1.CartVoucherFacade), i0.ɵɵdirectiveInject(i2$2.UntypedFormBuilder), i0.ɵɵdirectiveInject(i2.CustomerCouponService), i0.ɵɵdirectiveInject(i1.ActiveCartFacade));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CartCouponComponent,
      selectors: [["cx-cart-coupon"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "form-group"], [3, "ngSubmit", "formGroup"], ["id", "card-coupon-input-label", 1, "cx-cart-coupon-title"], [1, "cx-cart-coupon-container"], ["type", "text", "formControlName", "couponCode", 1, "form-control", "input-coupon-code", 3, "placeholder"], ["type", "submit", 1, "btn", "btn-block", "btn-secondary", "apply-coupon-button", 3, "disabled"], [3, "vouchers", "cartIsLoading", "isReadOnly"], [1, "cx-available-coupon"], [1, "title", "cx-cart-coupon-title"], [1, "message"], [1, "scroll"], ["class", "coupons card", 4, "ngFor", "ngForOf"], [1, "coupons", "card"], [1, "coupon-id", "link", 3, "click", "disabled"]],
      template: function CartCouponComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CartCouponComponent_ng_container_0_Template, 17, 24, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.cart$));
        }
      },
      dependencies: [i4.NgForOf, i4.NgIf, i2$2.ɵNgNoValidate, i2$2.DefaultValueAccessor, i2$2.NgControlStatus, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i2$2.FormControlName, AppliedCouponsComponent, i4.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartCouponComponent, [{
    type: Component,
    args: [{
      selector: 'cx-cart-coupon',
      standalone: false,
      template: "<ng-container *ngIf=\"cart$ | async as cart\">\n  <div class=\"form-group\">\n    <form (ngSubmit)=\"applyVoucher()\" [formGroup]=\"couponForm\">\n      <label id=\"card-coupon-input-label\" class=\"cx-cart-coupon-title\">\n        {{ 'voucher.addCoupon' | cxTranslate }}\n      </label>\n\n      <div class=\"cx-cart-coupon-container\">\n        <input\n          [attr.aria-labelledby]=\"'card-coupon-input-label'\"\n          type=\"text\"\n          class=\"form-control input-coupon-code\"\n          formControlName=\"couponCode\"\n          placeholder=\"{{ 'voucher.placeholder' | cxTranslate }}\"\n        />\n        <button\n          class=\"btn btn-block btn-secondary apply-coupon-button\"\n          type=\"submit\"\n          [disabled]=\"\n            (cartIsLoading$ | async) || !couponForm?.get('couponCode')?.value\n          \"\n          [class.disabled]=\"cartIsLoading$ | async\"\n        >\n          {{ 'voucher.apply' | cxTranslate }}\n        </button>\n      </div>\n    </form>\n  </div>\n\n  <cx-applied-coupons\n    [vouchers]=\"cart.appliedVouchers\"\n    [cartIsLoading]=\"cartIsLoading$ | async\"\n    [isReadOnly]=\"false\"\n  >\n  </cx-applied-coupons>\n\n  <ng-container *ngIf=\"applicableCoupons && applicableCoupons.length > 0\">\n    <div class=\"cx-available-coupon\">\n      <div class=\"title cx-cart-coupon-title\">\n        {{ 'voucher.availableCoupons' | cxTranslate }}\n      </div>\n      <div class=\"message\">\n        {{ 'voucher.availableCouponsLabel' | cxTranslate }}\n      </div>\n      <div class=\"scroll\">\n        <div class=\"coupons card\" *ngFor=\"let coupon of applicableCoupons\">\n          <button\n            (click)=\"applyCustomerCoupon(coupon.couponId)\"\n            class=\"coupon-id link\"\n            [disabled]=\"cartIsLoading$ | async\"\n            [class.disabled]=\"cartIsLoading$ | async\"\n          >\n            {{ coupon.couponId }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </ng-container>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.CartVoucherFacade
  }, {
    type: i2$2.UntypedFormBuilder
  }, {
    type: i2.CustomerCouponService
  }, {
    type: i1.ActiveCartFacade
  }], {
    featureConfigService: [{
      type: Optional
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartCouponModule {
  static {
    this.ɵfac = function CartCouponModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartCouponModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CartCouponModule,
      declarations: [CartCouponComponent, AppliedCouponsComponent],
      imports: [CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule, I18nModule, IconModule, FormErrorsModule, FeaturesConfigModule, FormRequiredLegendComponent],
      exports: [CartCouponComponent, AppliedCouponsComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          CartApplyCouponComponent: {
            component: CartCouponComponent
          }
        }
      })],
      imports: [CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule, I18nModule, IconModule, FormErrorsModule, FeaturesConfigModule, FormRequiredLegendComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartCouponModule, [{
    type: NgModule,
    args: [{
      declarations: [CartCouponComponent, AppliedCouponsComponent],
      exports: [CartCouponComponent, AppliedCouponsComponent],
      imports: [CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule, I18nModule, IconModule, FormErrorsModule, FeaturesConfigModule, FormRequiredLegendComponent],
      providers: [provideDefaultConfig({
        cmsComponents: {
          CartApplyCouponComponent: {
            component: CartCouponComponent
          }
        }
      })]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartItemValidationWarningModule {
  static {
    this.ɵfac = function CartItemValidationWarningModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartItemValidationWarningModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CartItemValidationWarningModule,
      declarations: [CartItemValidationWarningComponent],
      imports: [CommonModule, RouterModule, I18nModule, UrlModule, IconModule],
      exports: [CartItemValidationWarningComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule, I18nModule, UrlModule, IconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartItemValidationWarningModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, I18nModule, UrlModule, IconModule],
      exports: [CartItemValidationWarningComponent],
      declarations: [CartItemValidationWarningComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartItemListComponentService {
  showBasePriceWithDiscount() {
    return true;
  }
  static {
    this.ɵfac = function CartItemListComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartItemListComponentService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CartItemListComponentService,
      factory: CartItemListComponentService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartItemListComponentService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartItemListRowComponent extends CartItemComponent {
  constructor(cartItemContextSource) {
    super(cartItemContextSource);
    this.componentService = inject(CartItemListComponentService);
    this.isFlagQuote = this.componentService.showBasePriceWithDiscount();
    useFeatureStyles('a11yQTY2Quantity');
  }
  static {
    this.ɵfac = function CartItemListRowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartItemListRowComponent)(i0.ɵɵdirectiveInject(CartItemContextSource));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CartItemListRowComponent,
      selectors: [["", "cx-cart-item-list-row", ""], ["cx-cart-item-list-row"]],
      standalone: false,
      features: [i0.ɵɵProvidersFeature([CartItemContextSource, {
        provide: CartItemContext,
        useExisting: CartItemContextSource
      }]), i0.ɵɵInheritDefinitionFeature],
      attrs: _c7,
      decls: 3,
      vars: 1,
      consts: [["total", ""], ["forceInstock", ""], [3, "cxOutlet"], ["role", "cell"], [3, "code"], [1, "cx-table-item-container"], ["tabindex", "0", 3, "routerLink", 4, "ngIf"], ["format", "cartIcon", 3, "container", 4, "ngIf"], [1, "cx-info"], ["class", "cx-name", 4, "ngIf"], ["class", "cx-code", 4, "ngIf"], [4, "ngIf"], ["role", "columnheader", 3, "cxOutlet", "cxOutletContext"], [1, "cx-cart-addons"], [3, "promotions"], ["role", "cell", "class", "cx-price cx-mobile-only", 4, "ngIf"], ["role", "cell", 3, "cxOutlet", "cxOutletContext"], ["role", "cell", 1, "cx-quantity"], ["class", "cx-mobile-header", "placement", "left", 3, "title", 4, "cxFeature"], [1, "cx-value"], [3, "control", "readonly", "max", "allowZero"], [4, "ngIf", "ngIfElse"], ["role", "cell", "class", "cx-actions", 4, "ngIf"], ["tabindex", "0", 3, "routerLink"], ["format", "cartIcon", 3, "container"], [1, "cx-name"], ["class", "cx-link", 3, "routerLink", 4, "ngIf"], [1, "cx-link", 3, "routerLink"], [1, "cx-code"], ["class", "cx-price", 4, "ngIf"], [1, "cx-price"], ["class", "cx-value", 4, "ngIf"], [3, "cxOutlet", "cxOutletContext"], ["class", "cx-property", 4, "ngFor", "ngForOf"], [1, "cx-property"], ["class", "cx-label", 4, "ngIf"], [1, "cx-label"], ["role", "cell", 1, "cx-price", "cx-mobile-only"], [1, "cx-mobile-header"], ["placement", "left", 1, "cx-mobile-header", 3, "title"], ["role", "cell", 1, "cx-total"], ["class", "cx-value", 4, "ngIf", "ngIfElse"], ["role", "cell", 1, "cx-actions"], ["role", "cell", "class", "cx-availability", 4, "ngIf"], ["class", "btn btn-tertiary cx-remove-btn", 3, "cxAtMessage", "disabled", "click", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["role", "cell", 1, "cx-availability"], [1, "btn", "btn-tertiary", "cx-remove-btn", 3, "click", "cxAtMessage", "disabled"], ["role", "cell", "class", "cx-total", 4, "ngIf"]],
      template: function CartItemListRowComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CartItemListRowComponent_ng_template_0_Template, 26, 32, "ng-template", 2)(1, CartItemListRowComponent_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxOutlet", ctx.CartOutlets.LIST_ITEM);
        }
      },
      dependencies: [i2$1.AtMessageDirective, CartItemValidationWarningComponent, i4.NgForOf, i4.NgIf, i4.NgTemplateOutlet, i2$1.ItemCounterComponent, i2$1.MediaComponent, i2$1.OutletDirective, i2$1.PromotionsComponent, i1$1.RouterLink, i2.FeatureDirective, i2.TranslatePipe, i2.UrlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartItemListRowComponent, [{
    type: Component,
    args: [{
      selector: '[cx-cart-item-list-row], cx-cart-item-list-row',
      providers: [CartItemContextSource, {
        provide: CartItemContext,
        useExisting: CartItemContextSource
      }],
      standalone: false,
      template: "<!-- Item Start Outlet -->\n<ng-template [cxOutlet]=\"CartOutlets.LIST_ITEM\">\n  <td role=\"cell\">\n    <ng-template\n      [cxOutlet]=\"CartOutlets.ITEM_CONFIGURATOR_ISSUES\"\n    ></ng-template>\n    <cx-cart-item-validation-warning\n      [code]=\"item.product?.code\"\n    ></cx-cart-item-validation-warning>\n    <div class=\"cx-table-item-container\">\n      <!-- Item Image -->\n      <a\n        *ngIf=\"!options.disableItemLink\"\n        [routerLink]=\"{ cxRoute: 'product', params: item.product } | cxUrl\"\n        tabindex=\"0\"\n      >\n        <cx-media\n          [container]=\"item.product?.images?.PRIMARY\"\n          format=\"cartIcon\"\n        ></cx-media>\n      </a>\n      <cx-media\n        *ngIf=\"options.disableItemLink\"\n        [container]=\"item.product?.images?.PRIMARY\"\n        format=\"cartIcon\"\n      ></cx-media>\n      <div class=\"cx-info\">\n        <div *ngIf=\"item.product?.name\" class=\"cx-name\">\n          <a\n            *ngIf=\"!options.disableItemLink\"\n            class=\"cx-link\"\n            [routerLink]=\"{ cxRoute: 'product', params: item.product } | cxUrl\"\n            >{{ item.product?.name }}</a\n          >\n          <span *ngIf=\"options.disableItemLink\">{{ item.product?.name }}</span>\n        </div>\n        <div *ngIf=\"item.product?.code\" class=\"cx-code\">\n          {{ 'cartItems.id' | cxTranslate }} {{ item.product?.code }}\n        </div>\n        <!-- Item Price -->\n        <ng-container *ngIf=\"isFlagQuote\">\n          <div *ngIf=\"item.basePrice\" class=\"cx-price\">\n            <div *ngIf=\"item.basePrice\" class=\"cx-value\">\n              {{ item.basePrice?.formattedValue }}\n            </div>\n          </div></ng-container\n        >\n        <ng-template\n          role=\"columnheader\"\n          [cxOutlet]=\"CartOutlets.CPQ_QUOTE\"\n          [cxOutletContext]=\"{\n            items: item,\n          }\"\n        ></ng-template>\n      </div>\n    </div>\n    <div class=\"cx-cart-addons\">\n      <!-- Item Details Outlet -->\n      <ng-template [cxOutlet]=\"CartOutlets.ITEM_DETAILS\"> </ng-template>\n\n      <!-- Item Bundle Details Outlet -->\n      <ng-template [cxOutlet]=\"CartOutlets.ITEM_BUNDLE_DETAILS\"> </ng-template>\n\n      <!-- Promotion -->\n      <cx-promotions [promotions]=\"item.promotions\"></cx-promotions>\n\n      <!-- Item Delivery Details Outlet -->\n      <ng-template\n        *ngIf=\"!readonly\"\n        [cxOutlet]=\"CartOutlets.ITEM_DELIVERY_DETAILS\"\n        [cxOutletContext]=\"{ item, cartType: options.cartType }\"\n      ></ng-template>\n    </div>\n\n    <!-- Variants -->\n    <ng-container *ngIf=\"item.product?.baseOptions?.length\">\n      <div\n        *ngFor=\"\n          let variant of item.product?.baseOptions[0]?.selected\n            ?.variantOptionQualifiers\n        \"\n        class=\"cx-property\"\n      >\n        <!-- cx-mobile-header -->\n        <div class=\"cx-label\" *ngIf=\"variant.name && variant.value\">\n          {{ variant.name }}: {{ variant.value }}\n        </div>\n      </div>\n    </ng-container>\n  </td>\n  <!-- Mobile Item Price -->\n  <td role=\"cell\" *ngIf=\"item.basePrice\" class=\"cx-price cx-mobile-only\">\n    <div class=\"cx-mobile-header\">\n      {{ 'cartItems.itemPrice' | cxTranslate }}\n    </div>\n    <div *ngIf=\"item.basePrice\" class=\"cx-value\">\n      {{ item.basePrice?.formattedValue }}\n    </div>\n  </td>\n\n  <!-- item price with discount -->\n  <ng-template\n    role=\"cell\"\n    [cxOutlet]=\"CartOutlets.CPQ_QUOTE_MODULE\"\n    [cxOutletContext]=\"{\n      items: item,\n    }\"\n  ></ng-template>\n\n  <!-- Item Quantity -->\n  <td role=\"cell\" class=\"cx-quantity\">\n    <div\n      *cxFeature=\"'a11yQTY2Quantity'\"\n      class=\"cx-mobile-header\"\n      placement=\"left\"\n      title=\"{{ 'cartItems.quantityTitle' | cxTranslate }}\"\n    >\n      {{ 'cartItems.quantityFull' | cxTranslate }}\n    </div>\n    <div\n      *cxFeature=\"'!a11yQTY2Quantity'\"\n      class=\"cx-mobile-header\"\n      placement=\"left\"\n      title=\"{{ 'cartItems.quantityTitle' | cxTranslate }}\"\n    >\n      {{ 'cartItems.quantity' | cxTranslate }}\n    </div>\n    <div class=\"cx-value\" [class.readonly-value]=\"readonly\">\n      <cx-item-counter\n        [control]=\"quantityControl\"\n        [readonly]=\"!item.updateable || readonly || options.isSaveForLater\"\n        [max]=\"item.product?.stock?.stockLevel\"\n        [allowZero]=\"true\"\n      >\n      </cx-item-counter>\n    </div>\n  </td>\n  <!-- Total -->\n  <ng-container *ngIf=\"options.isSaveForLater; else total\">\n    <td role=\"cell\" class=\"cx-total\">\n      <div class=\"cx-mobile-header\">\n        {{ 'saveForLaterItems.stock' | cxTranslate }}\n      </div>\n      <div\n        *ngIf=\"item.product?.stock?.stockLevel >= 0; else forceInstock\"\n        class=\"cx-value\"\n      >\n        {{ item.product?.stock.stockLevel }}\n      </div>\n      <ng-template #forceInstock>\n        <div class=\"cx-value\">\n          {{ 'saveForLaterItems.forceInStock' | cxTranslate }}\n        </div>\n      </ng-template>\n    </td>\n  </ng-container>\n\n  <td\n    role=\"cell\"\n    *ngIf=\"\n      (!readonly || options.isSaveForLater || options.displayAddToCart) &&\n      item.updateable\n    \"\n    class=\"cx-actions\"\n  >\n    <ng-container *ngIf=\"!isProductOutOfStock(item.product)\">\n      <ng-container\n        *ngTemplateOutlet=\"\n          options.optionalBtn;\n          context: {\n            $implicit: {\n              loading: quantityControl.disabled,\n              item: this.item,\n              options: this.options,\n            },\n          }\n        \"\n      ></ng-container>\n    </ng-container>\n\n    <!-- Availability -->\n    <span\n      role=\"cell\"\n      *ngIf=\"isProductOutOfStock(item.product)\"\n      class=\"cx-availability\"\n    >\n      {{ 'addToCart.outOfStock' | cxTranslate }}\n    </span>\n\n    <button\n      *ngIf=\"!readonly\"\n      (click)=\"removeItem()\"\n      [cxAtMessage]=\"'cartItems.itemRemoved' | cxTranslate\"\n      [disabled]=\"quantityControl.disabled\"\n      attr.aria-label=\"{{ 'addToCart.removeFromCart' | cxTranslate }}\"\n      class=\"btn btn-tertiary cx-remove-btn\"\n    >\n      {{ 'common.remove' | cxTranslate }}\n    </button>\n  </td>\n</ng-template>\n<ng-template #total>\n  <td role=\"cell\" *ngIf=\"item.totalPrice\" class=\"cx-total\">\n    <div class=\"cx-mobile-header\">\n      {{ 'cartItems.total' | cxTranslate }}\n    </div>\n    <div class=\"cx-value\">{{ item.totalPrice.formattedValue }}</div>\n  </td>\n</ng-template>\n"
    }]
  }], () => [{
    type: CartItemContextSource
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartItemListComponent {
  set items(items) {
    this._setItems(items);
  }
  get items() {
    return this._items;
  }
  set setLoading(value) {
    if (!this.readonly) {
      // Whenever the cart is loading, we disable the complete form
      // to avoid any user interaction with the cart.
      value ? this.form.disable({
        emitEvent: false
      }) : this.form.enable({
        emitEvent: false
      });
      this.cd.markForCheck();
    }
  }
  constructor(activeCartService, selectiveCartService, userIdService, multiCartService, cd, outlet) {
    this.activeCartService = activeCartService;
    this.selectiveCartService = selectiveCartService;
    this.userIdService = userIdService;
    this.multiCartService = multiCartService;
    this.cd = cd;
    this.outlet = outlet;
    this.subscription = new Subscription();
    this.readonly = false;
    this.hasHeader = true;
    this.options = {
      isSaveForLater: false,
      optionalBtn: null,
      displayAddToCart: false
    };
    this._items = [];
    this.form = new UntypedFormGroup({});
    this.promotionLocation = PromotionLocation.ActiveCart;
    this.CartOutlets = CartOutlets;
    this.featureConfigService = inject(FeatureConfigService);
    useFeatureStyles('a11yPreventHorizontalScroll');
    useFeatureStyles('a11yQTY2Quantity');
    useFeatureStyles('a11yPickupOptionsTabs');
    useFeatureStyles('a11yCroppedFocusRing');
  }
  ngOnInit() {
    this.subscription.add(this.getInputsFromContext());
    this.subscription.add(this.userIdService?.getUserId().subscribe(userId => this.userId = userId));
  }
  _setItems(items, options) {
    this.resolveItems(items, options);
    this.createForm();
  }
  getInputsFromContext() {
    return this.outlet?.context$.subscribe(context => {
      let contextRequiresRerender = false;
      if (context.readonly !== undefined) {
        contextRequiresRerender = this.readonly !== context.readonly;
        this.readonly = context.readonly;
      }
      if (context.hasHeader !== undefined) {
        this.hasHeader = context.hasHeader;
      }
      if (context.options !== undefined) {
        this.options = context.options;
      }
      if (context.cartId !== undefined) {
        this.cartId = context.cartId;
      }
      if (context.promotionLocation !== undefined) {
        this.promotionLocation = context.promotionLocation;
      }
      if (context.cartIsLoading !== undefined) {
        this.setLoading = context.cartIsLoading;
      }
      this.updateItemsOnContextChange(context, contextRequiresRerender);
    });
  }
  updateItemsOnContextChange(context, contextRequiresRerender) {
    const preventRedundantRecreationEnabled = this.featureConfigService.isEnabled('a11yPreventCartItemsFormRedundantRecreation');
    if (context.items !== undefined && (!preventRedundantRecreationEnabled || contextRequiresRerender || this.isItemsChanged(context.items))) {
      this.cd.markForCheck();
      this._setItems(context.items, {
        forceRerender: contextRequiresRerender
      });
    }
  }
  isItemsChanged(newItems) {
    return JSON.stringify(this.items) !== JSON.stringify(newItems);
  }
  /**
   * Resolves items passed to component input and updates 'items' field
   */
  resolveItems(items, options) {
    if (!items) {
      this._items = [];
      return;
    }
    // The items we're getting from the input do not have a consistent model.
    // In case of a `consignmentEntry`, we need to normalize the data from the orderEntry.
    if (items.every(item => item.hasOwnProperty('orderEntry'))) {
      this.normalizeConsignmentEntries(items);
    } else {
      this.rerenderChangedItems(items, options);
    }
  }
  normalizeConsignmentEntries(items) {
    this._items = items.map(consignmentEntry => {
      const entry = Object.assign({}, consignmentEntry.orderEntry);
      entry.quantity = consignmentEntry.quantity;
      return entry;
    });
  }
  /**
   * We'd like to avoid the unnecessary re-renders of unchanged cart items after the data reload.
   * OCC cart entries don't have any unique identifier that we could use in Angular `trackBy`.
   * So we update each array element to the new object only when it's any different to the previous one.
   */
  rerenderChangedItems(items, options) {
    let offset = 0;
    for (let i = 0; i - offset < Math.max(items.length, this._items.length); i++) {
      const index = i - offset;
      if (options?.forceRerender || JSON.stringify(this._items?.[index]) !== JSON.stringify(items[index])) {
        if (this._items[index]) {
          this.form?.removeControl(this.getControlName(this._items[index]));
        }
        if (!items[index]) {
          this._items.splice(index, 1);
          offset++;
        } else {
          this._items[index] = items[index];
        }
      }
    }
  }
  /**
   * Creates form models for list items
   */
  createForm() {
    this._items.forEach(item => {
      const controlName = this.getControlName(item);
      const control = this.form.get(controlName);
      if (control) {
        if (control.get('quantity')?.value !== item.quantity) {
          control.patchValue({
            quantity: item.quantity
          }, {
            emitEvent: false
          });
        }
      } else {
        const group = new UntypedFormGroup({
          entryNumber: new UntypedFormControl(item.entryNumber),
          quantity: new UntypedFormControl(item.quantity, {
            updateOn: 'blur'
          })
        });
        this.form.addControl(controlName, group);
      }
      // If we disable form group before adding, disabled status will reset
      // Which forces us to disable control after including to form object
      if (!item.updateable || this.readonly) {
        this.form.controls[controlName].disable();
      }
    });
  }
  getControlName(item) {
    return item.entryNumber?.toString() || '';
  }
  removeEntry(item) {
    if (this.options.isSaveForLater) {
      this.selectiveCartService.removeEntry(item);
    } else if (this.cartId && this.userId) {
      this.multiCartService.removeEntry(this.userId, this.cartId, item.entryNumber);
    } else {
      this.activeCartService.removeEntry(item);
    }
    delete this.form.controls[this.getControlName(item)];
  }
  getControl(item) {
    return this.form.get(this.getControlName(item))?.valueChanges.pipe(
    // eslint-disable-next-line import/no-deprecated
    startWith(null), tap(value => {
      if (item.updateable && value && !this.readonly) {
        if (this.options.isSaveForLater) {
          this.selectiveCartService.updateEntry(value.entryNumber, value.quantity);
        } else if (this.cartId && this.userId) {
          this.multiCartService.updateEntry(this.userId, this.cartId, value.entryNumber, value.quantity);
        } else {
          this.activeCartService.updateEntry(value.entryNumber, value.quantity);
        }
      }
    }), map(() => this.form.get(this.getControlName(item))));
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  static {
    this.ɵfac = function CartItemListComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartItemListComponent)(i0.ɵɵdirectiveInject(i1.ActiveCartFacade), i0.ɵɵdirectiveInject(i1.SelectiveCartFacade), i0.ɵɵdirectiveInject(i2.UserIdService), i0.ɵɵdirectiveInject(i1.MultiCartFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2$1.OutletContextData, 8));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CartItemListComponent,
      selectors: [["cx-cart-item-list"]],
      inputs: {
        readonly: "readonly",
        hasHeader: "hasHeader",
        options: "options",
        cartId: "cartId",
        items: "items",
        promotionLocation: "promotionLocation",
        setLoading: [0, "cartIsLoading", "setLoading"]
      },
      standalone: false,
      decls: 9,
      vars: 5,
      consts: [["totalHeader", ""], ["role", "table"], [1, "cx-visually-hidden"], [4, "ngIf"], [1, "cx-item-list-items"], [4, "ngFor", "ngForOf"], ["role", "row", 1, "cx-item-list-header"], ["role", "columnheader", "scope", "col", 1, "cx-item-list-desc"], ["role", "columnheader", 3, "cxOutlet", "cxOutletContext"], ["role", "columnheader", "scope", "col", "class", "cx-item-list-qty", 4, "cxFeature"], [4, "ngIf", "ngIfElse"], ["role", "columnheader", "scope", "col", 1, "cx-item-list-qty"], ["role", "columnheader", "scope", "col", 1, "cx-item-list-total"], ["role", "columnheader", "scope", "col", 1, "cx-item-list-actions"], [3, "is-changed", 4, "ngIf"], ["cx-cart-item-list-row", "", "role", "row", 1, "cx-item-list-row", 3, "item", "quantityControl", "readonly", "promotionLocation", "options"]],
      template: function CartItemListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "table", 1)(1, "caption", 2);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(4, CartItemListComponent_thead_4_Template, 10, 10, "thead", 3);
          i0.ɵɵelementStart(5, "tbody", 4);
          i0.ɵɵtemplate(6, CartItemListComponent_ng_container_6_Template, 3, 3, "ng-container", 5);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(7, CartItemListComponent_ng_template_7_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "cartItems.caption"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.hasHeader);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.items);
        }
      },
      dependencies: [i4.NgForOf, i4.NgIf, i2$1.OutletDirective, i2.FeatureDirective, CartItemListRowComponent, i4.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartItemListComponent, [{
    type: Component,
    args: [{
      selector: 'cx-cart-item-list',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<table role=\"table\">\n  <caption class=\"cx-visually-hidden\">\n    {{\n      'cartItems.caption' | cxTranslate\n    }}\n  </caption>\n  <thead *ngIf=\"hasHeader\">\n    <tr role=\"row\" class=\"cx-item-list-header\">\n      <th role=\"columnheader\" scope=\"col\" class=\"cx-item-list-desc\">\n        {{ 'cartItems.item' | cxTranslate }}\n      </th>\n\n      <ng-template\n        role=\"columnheader\"\n        [cxOutlet]=\"CartOutlets.CPQ_QUOTE_HEADING\"\n        [cxOutletContext]=\"items\"\n      ></ng-template>\n      <th\n        *cxFeature=\"'a11yQTY2Quantity'\"\n        role=\"columnheader\"\n        scope=\"col\"\n        class=\"cx-item-list-qty\"\n      >\n        {{ 'cartItems.quantityFull' | cxTranslate }}\n      </th>\n      <th\n        *cxFeature=\"'!a11yQTY2Quantity'\"\n        role=\"columnheader\"\n        scope=\"col\"\n        class=\"cx-item-list-qty\"\n      >\n        {{ 'cartItems.quantity' | cxTranslate }}\n      </th>\n      <ng-container *ngIf=\"options.isSaveForLater; else totalHeader\">\n        <th role=\"columnheader\" scope=\"col\" class=\"cx-item-list-total\">\n          {{ 'saveForLaterItems.stock' | cxTranslate }}\n        </th>\n      </ng-container>\n      <ng-container\n        *ngIf=\"!readonly || options.isSaveForLater || options.displayAddToCart\"\n      >\n        <th role=\"columnheader\" scope=\"col\" class=\"cx-item-list-actions\">\n          {{ 'cartItems.actions' | cxTranslate }}\n        </th>\n      </ng-container>\n    </tr>\n  </thead>\n  <tbody class=\"cx-item-list-items\">\n    <ng-container *ngFor=\"let item of items; let i = index\">\n      <ng-container\n        *ngIf=\"getControl(item) | async as control\"\n        [class.is-changed]=\"control.get('quantity').disabled\"\n      >\n        <tr\n          cx-cart-item-list-row\n          role=\"row\"\n          class=\"cx-item-list-row\"\n          [item]=\"item\"\n          [quantityControl]=\"control.get('quantity')\"\n          [readonly]=\"readonly\"\n          [promotionLocation]=\"promotionLocation\"\n          [options]=\"options\"\n          [attr.aria-rowindex]=\"i + 1\"\n        ></tr>\n      </ng-container>\n    </ng-container>\n  </tbody>\n</table>\n\n<ng-template #totalHeader>\n  <th role=\"columnheader\" scope=\"col\" class=\"cx-item-list-total\">\n    {{ 'cartItems.total' | cxTranslate }}\n  </th>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1.ActiveCartFacade
  }, {
    type: i1.SelectiveCartFacade
  }, {
    type: i2.UserIdService
  }, {
    type: i1.MultiCartFacade
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i2$1.OutletContextData,
    decorators: [{
      type: Optional
    }]
  }], {
    readonly: [{
      type: Input
    }],
    hasHeader: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    cartId: [{
      type: Input
    }],
    items: [{
      type: Input,
      args: ['items']
    }],
    promotionLocation: [{
      type: Input
    }],
    setLoading: [{
      type: Input,
      args: ['cartIsLoading']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderSummaryComponent {
  constructor(outlet) {
    this.outlet = outlet;
    this.subscription = new Subscription();
  }
  ngOnInit() {
    if (this.outlet?.context$) {
      this.subscription.add(this.outlet.context$.subscribe(context => this.cart = context));
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function OrderSummaryComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderSummaryComponent)(i0.ɵɵdirectiveInject(i2$1.OutletContextData, 8));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderSummaryComponent,
      selectors: [["cx-order-summary"]],
      inputs: {
        cart: "cart"
      },
      standalone: false,
      decls: 5,
      vars: 6,
      consts: [["cartWithoutNet", ""], [1, "cx-summary-heading"], ["class", "cx-summary-partials", 4, "ngIf"], [3, "vouchers", "isReadOnly"], [1, "cx-summary-partials"], [1, "cx-summary-row"], [1, "col-6", "cx-summary-label"], [1, "col-6", "cx-summary-amount"], ["class", "cx-summary-row", 4, "ngIf", "ngIfElse"], [1, "cx-summary-row", "cx-summary-total"], ["class", "cx-summary-row", 4, "ngIf"]],
      template: function OrderSummaryComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "h3", 1);
          i0.ɵɵtext(1);
          i0.ɵɵpipe(2, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(3, OrderSummaryComponent_div_3_Template, 24, 17, "div", 2);
          i0.ɵɵelement(4, "cx-applied-coupons", 3);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, "orderCost.orderSummary"), "\n");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.cart);
          i0.ɵɵadvance();
          i0.ɵɵproperty("vouchers", ctx.cart.appliedVouchers)("isReadOnly", true);
        }
      },
      dependencies: [AppliedCouponsComponent, i4.NgIf, i2.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderSummaryComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-summary',
      standalone: false,
      template: "<h3 class=\"cx-summary-heading\">\n  {{ 'orderCost.orderSummary' | cxTranslate }}\n</h3>\n\n<div class=\"cx-summary-partials\" *ngIf=\"cart\">\n  <div class=\"cx-summary-row\">\n    <div class=\"col-6 cx-summary-label\">\n      {{ 'orderCost.subtotal' | cxTranslate }}\n    </div>\n    <div class=\"col-6 cx-summary-amount\">\n      {{ cart.subTotal?.formattedValue }}\n    </div>\n  </div>\n  <div class=\"cx-summary-row\">\n    <div class=\"col-6 cx-summary-label\">\n      {{\n        (cart.deliveryCost?.formattedValue\n          ? 'orderCost.shipping'\n          : 'orderCost.estimatedShipping'\n        ) | cxTranslate\n      }}\n    </div>\n    <div class=\"col-6 cx-summary-amount\">\n      {{\n        cart.deliveryCost?.formattedValue\n          ? cart.deliveryCost?.formattedValue\n          : ('orderCost.toBeDetermined' | cxTranslate)\n      }}\n    </div>\n  </div>\n  <div class=\"cx-summary-row\" *ngIf=\"cart.net; else cartWithoutNet\">\n    <div class=\"col-6 cx-summary-label\">\n      {{ 'orderCost.salesTax' | cxTranslate }}\n    </div>\n    <div class=\"col-6 cx-summary-amount\">\n      {{ cart.totalTax?.formattedValue }}\n    </div>\n  </div>\n  <div class=\"cx-summary-row cx-summary-total\">\n    <div class=\"col-6 cx-summary-label\">\n      {{ 'orderCost.total' | cxTranslate }}\n    </div>\n    <div class=\"col-6 cx-summary-amount\">\n      {{ cart.totalPriceWithTax?.formattedValue }}\n    </div>\n  </div>\n  <div class=\"cx-summary-row\" *ngIf=\"cart.totalDiscounts?.value > 0\">\n    {{ 'orderCost.discount' | cxTranslate }}\n    {{ cart.totalDiscounts?.formattedValue }}\n  </div>\n  <ng-template #cartWithoutNet>\n    <div class=\"cx-summary-row\">\n      {{\n        cart.totalPriceWithTax?.value !== cart.totalPrice?.value\n          ? ('orderCost.grossTax' | cxTranslate)\n          : ('orderCost.grossIncludeTax' | cxTranslate)\n      }}\n      {{ cart.totalTax?.formattedValue }}.\n    </div>\n  </ng-template>\n</div>\n\n<cx-applied-coupons\n  [vouchers]=\"cart.appliedVouchers\"\n  [isReadOnly]=\"true\"\n></cx-applied-coupons>\n"
    }]
  }], () => [{
    type: i2$1.OutletContextData,
    decorators: [{
      type: Optional
    }]
  }], {
    cart: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartSharedModule {
  static {
    this.ɵfac = function CartSharedModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartSharedModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CartSharedModule,
      declarations: [CartItemComponent, OrderSummaryComponent, CartItemListComponent, CartItemListRowComponent],
      imports: [AtMessageModule, CartCouponModule, CartItemValidationWarningModule, CommonModule, I18nModule, IconModule, ItemCounterModule, MediaModule, OutletModule, PromotionsModule, ReactiveFormsModule, RouterModule, UrlModule, AddToCartModule, FeaturesConfigModule],
      exports: [CartItemComponent, CartItemListRowComponent, CartItemListComponent, OrderSummaryComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideOutlet({
        id: CartOutlets.ORDER_SUMMARY,
        component: OrderSummaryComponent
      }), provideOutlet({
        id: CartOutlets.CART_ITEM_LIST,
        component: CartItemListComponent
      })],
      imports: [AtMessageModule, CartCouponModule, CartItemValidationWarningModule, CommonModule, I18nModule, IconModule, ItemCounterModule, MediaModule, OutletModule, PromotionsModule, ReactiveFormsModule, RouterModule, UrlModule, AddToCartModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartSharedModule, [{
    type: NgModule,
    args: [{
      imports: [AtMessageModule, CartCouponModule, CartItemValidationWarningModule, CommonModule, I18nModule, IconModule, ItemCounterModule, MediaModule, OutletModule, PromotionsModule, ReactiveFormsModule, RouterModule, UrlModule, AddToCartModule, FeaturesConfigModule],
      providers: [provideOutlet({
        id: CartOutlets.ORDER_SUMMARY,
        component: OrderSummaryComponent
      }), provideOutlet({
        id: CartOutlets.CART_ITEM_LIST,
        component: CartItemListComponent
      })],
      declarations: [CartItemComponent, OrderSummaryComponent, CartItemListComponent, CartItemListRowComponent],
      exports: [CartItemComponent, CartItemListRowComponent, CartItemListComponent, OrderSummaryComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultAddedToCartLayoutConfig = {
  launch: {
    ADDED_TO_CART: {
      inlineRoot: true,
      component: AddedToCartDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddedToCartDialogModule {
  constructor(_addToCartDialogEventListener) {
    // Intentional empty constructor
  }
  static {
    this.ɵfac = function AddedToCartDialogModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddedToCartDialogModule)(i0.ɵɵinject(AddedToCartDialogEventListener));
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AddedToCartDialogModule,
      declarations: [AddedToCartDialogComponent],
      imports: [CommonModule, ReactiveFormsModule, CartSharedModule, RouterModule, SpinnerModule, PromotionsModule, UrlModule, IconModule, I18nModule, ItemCounterModule, KeyboardFocusModule, FeaturesConfigModule, BtnLikeLinkModule],
      exports: [AddedToCartDialogComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultAddedToCartLayoutConfig)],
      imports: [CommonModule, ReactiveFormsModule, CartSharedModule, RouterModule, SpinnerModule, PromotionsModule, UrlModule, IconModule, I18nModule, ItemCounterModule, KeyboardFocusModule, FeaturesConfigModule, BtnLikeLinkModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddedToCartDialogModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, CartSharedModule, RouterModule, SpinnerModule, PromotionsModule, UrlModule, IconModule, I18nModule, ItemCounterModule, KeyboardFocusModule, FeaturesConfigModule, BtnLikeLinkModule],
      providers: [provideDefaultConfig(defaultAddedToCartLayoutConfig)],
      declarations: [AddedToCartDialogComponent],
      exports: [AddedToCartDialogComponent]
    }]
  }], () => [{
    type: AddedToCartDialogEventListener
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ClearCartComponent {
  constructor(activeCartFacade, vcr, launchDialogService) {
    this.activeCartFacade = activeCartFacade;
    this.vcr = vcr;
    this.launchDialogService = launchDialogService;
    this.cart$ = this.activeCartFacade.getActive();
    this.subscription = new Subscription();
  }
  openDialog(event) {
    const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.CLEAR_CART, this.element, this.vcr);
    if (dialog) {
      this.subscription.add(dialog.pipe(take(1)).subscribe());
    }
    event.stopPropagation();
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  static {
    this.ɵfac = function ClearCartComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ClearCartComponent)(i0.ɵɵdirectiveInject(i1.ActiveCartFacade), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i2$1.LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ClearCartComponent,
      selectors: [["cx-clear-cart"]],
      viewQuery: function ClearCartComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c11, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["element", ""], [4, "ngIf"], ["class", "clear-cart-wrapper", 4, "ngIf"], [1, "clear-cart-wrapper"], ["type", "button", 1, "btn", "btn-tertiary", "clear-cart-btn", 3, "click"]],
      template: function ClearCartComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ClearCartComponent_ng_container_0_Template, 2, 1, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.cart$));
        }
      },
      dependencies: [i4.NgIf, i4.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClearCartComponent, [{
    type: Component,
    args: [{
      selector: 'cx-clear-cart',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"cart$ | async as cart\">\n  <div *ngIf=\"cart.totalItems > 0\" class=\"clear-cart-wrapper\">\n    <button\n      #element\n      (click)=\"openDialog($event)\"\n      class=\"btn btn-tertiary clear-cart-btn\"\n      type=\"button\"\n    >\n      {{ 'clearCart.clearCart' | cxTranslate }}\n    </button>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.ActiveCartFacade
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i2$1.LaunchDialogService
  }], {
    element: [{
      type: ViewChild,
      args: ['element']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ClearCartDialogComponentService {
  constructor(launchDialogService, globalMessageService, activeCartFacade, multiCartFacade, userIdService, eventService) {
    this.launchDialogService = launchDialogService;
    this.globalMessageService = globalMessageService;
    this.activeCartFacade = activeCartFacade;
    this.multiCartFacade = multiCartFacade;
    this.userIdService = userIdService;
    this.eventService = eventService;
  }
  /**
   * Clear the cart by deleting the active cart.
   */
  deleteActiveCart() {
    this.activeCartFacade.getActiveCartId().pipe(withLatestFrom(this.userIdService.getUserId()), take(1), tap(([cartId, userId]) => {
      this.multiCartFacade.deleteCart(cartId, userId);
    }), switchMap(() => merge(this.eventService.get(DeleteCartSuccessEvent).pipe(map(() => true)), this.eventService.get(DeleteCartFailEvent).pipe(map(() => false))).pipe(take(1))), tap(() => this.closeDialog('Close dialog after cart cleared'))).subscribe(success => {
      this.displayGlobalMessage(success);
    });
  }
  /**
   * Close clear cart modal dialog
   *
   * @param reason to close dialog
   */
  closeDialog(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  /**
   * Display global message after clearing cart.
   * By default, only message displayed is of type `Success`. A negative scenario
   * related to cart has been handled in the occ layer already.
   *
   * @param success result of clear cart action
   */
  displayGlobalMessage(success) {
    if (success) {
      this.globalMessageService.add({
        key: 'clearCart.cartClearedSuccessfully'
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }
  }
  static {
    this.ɵfac = function ClearCartDialogComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ClearCartDialogComponentService)(i0.ɵɵinject(i2$1.LaunchDialogService), i0.ɵɵinject(i2.GlobalMessageService), i0.ɵɵinject(i1.ActiveCartFacade), i0.ɵɵinject(i1.MultiCartFacade), i0.ɵɵinject(i2.UserIdService), i0.ɵɵinject(i2.EventService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ClearCartDialogComponentService,
      factory: ClearCartDialogComponentService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClearCartDialogComponentService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i2$1.LaunchDialogService
  }, {
    type: i2.GlobalMessageService
  }, {
    type: i1.ActiveCartFacade
  }, {
    type: i1.MultiCartFacade
  }, {
    type: i2.UserIdService
  }, {
    type: i2.EventService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ClearCartDialogComponent {
  handleClick(event) {
    // Close on click outside the dialog window
    if (event.target.tagName === this.el.nativeElement.tagName) {
      this.close('Cross click');
    }
  }
  constructor(el, clearCartDialogComponentService) {
    this.el = el;
    this.clearCartDialogComponentService = clearCartDialogComponentService;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: 'button.btn-primary',
      focusOnEscape: true
    };
    this.isClearing = false;
    this.iconTypes = ICON_TYPE;
  }
  clearCart() {
    this.isClearing = true;
    this.clearCartDialogComponentService.deleteActiveCart();
  }
  close(reason) {
    this.clearCartDialogComponentService.closeDialog(reason);
  }
  ngOnDestroy() {
    this.close('close dialog on component destroy');
  }
  static {
    this.ɵfac = function ClearCartDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ClearCartDialogComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(ClearCartDialogComponentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ClearCartDialogComponent,
      selectors: [["cx-clear-cart-dialog"]],
      hostBindings: function ClearCartDialogComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function ClearCartDialogComponent_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
      },
      standalone: false,
      decls: 5,
      vars: 3,
      consts: [["loading", ""], ["role", "dialog", "aria-labelledby", "dialogTitle", 1, "modal-dialog", "modal-dialog-centered", "cx-clear-cart-dialog", 3, "esc", "cxFocus"], [1, "modal-content", "cx-clear-cart-container"], [4, "ngIf", "ngIfElse"], ["role", "status", 4, "cxFeature"], [1, "modal-header", "cx-clear-cart-header"], ["id", "dialogTitle", "class", "cx-clear-cart-title modal-title", 4, "cxFeature"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], [1, "modal-body", "cx-clear-cart-body"], [1, "clear-cart-msg"], ["role", "alert", 1, "clear-cart-warning"], [1, "cx-clear-cart-footer"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], ["role", "status"], ["id", "dialogTitle", 1, "cx-clear-cart-title", "modal-title"], ["class", "cx-clear-cart-title modal-title", 4, "cxFeature"], [1, "cx-spinner"], [1, "cx-clear-cart-title", "modal-title"]],
      template: function ClearCartDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵlistener("esc", function ClearCartDialogComponent_Template_div_esc_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.close("Escape clicked"));
          });
          i0.ɵɵelementStart(1, "div", 2);
          i0.ɵɵtemplate(2, ClearCartDialogComponent_ng_container_2_Template, 25, 22, "ng-container", 3);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(3, ClearCartDialogComponent_ng_template_3_Template, 5, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const loading_r4 = i0.ɵɵreference(4);
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.isClearing)("ngIfElse", loading_r4);
        }
      },
      dependencies: [i4.NgIf, i2$1.SpinnerComponent, i2$1.IconComponent, i2$1.FocusDirective, i2.FeatureDirective, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClearCartDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-clear-cart-dialog',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  class=\"modal-dialog modal-dialog-centered cx-clear-cart-dialog\"\n  role=\"dialog\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"modal-content cx-clear-cart-container\">\n    <ng-container *ngIf=\"!isClearing; else loading\">\n      <div\n        *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n        role=\"status\"\n        [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n      ></div>\n      <!-- Modal Header -->\n      <div class=\"modal-header cx-clear-cart-header\">\n        <h3\n          *cxFeature=\"'a11yDialogsHeading'\"\n          id=\"dialogTitle\"\n          class=\"cx-clear-cart-title modal-title\"\n        >\n          {{ 'clearCart.clearCart' | cxTranslate }}\n        </h3>\n        <div\n          *cxFeature=\"'!a11yDialogsHeading'\"\n          id=\"dialogTitle\"\n          class=\"cx-clear-cart-title modal-title\"\n        >\n          {{ 'clearCart.clearCart' | cxTranslate }}\n        </div>\n\n        <button\n          (click)=\"close('Close Clear Cart Dialog')\"\n          [attr.aria-label]=\"'common.close' | cxTranslate\"\n          class=\"close\"\n          type=\"button\"\n          title=\"{{ 'common.close' | cxTranslate }}\"\n        >\n          <span aria-hidden=\"true\">\n            <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n          </span>\n        </button>\n      </div>\n\n      <!-- Modal Body -->\n      <div class=\"modal-body cx-clear-cart-body\">\n        <div class=\"clear-cart-msg\">\n          {{ 'clearCart.allItemsWillBeRemoved' | cxTranslate }}\n        </div>\n        <div class=\"clear-cart-warning\" role=\"alert\">\n          {{ 'clearCart.areYouSureToClearCart' | cxTranslate }}\n        </div>\n        <div>\n          <div class=\"cx-clear-cart-footer\">\n            <button\n              (click)=\"close('Cancel Clear Cart')\"\n              class=\"btn btn-secondary\"\n              type=\"button\"\n            >\n              {{ 'common.cancel' | cxTranslate }}\n            </button>\n            <button (click)=\"clearCart()\" class=\"btn btn-primary\" type=\"button\">\n              {{ 'clearCart.clearCart' | cxTranslate }}\n            </button>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n  </div>\n</div>\n\n<ng-template #loading>\n  <div class=\"modal-header cx-clear-cart-header\">\n    <h2\n      *cxFeature=\"'a11yDialogsHeading'\"\n      class=\"cx-clear-cart-title modal-title\"\n    >\n      {{ 'clearCart.clearingCart' | cxTranslate }}\n    </h2>\n    <div\n      *cxFeature=\"'!a11yDialogsHeading'\"\n      class=\"cx-clear-cart-title modal-title\"\n    >\n      {{ 'clearCart.clearingCart' | cxTranslate }}\n    </div>\n  </div>\n  <div class=\"cx-spinner\">\n    <cx-spinner></cx-spinner>\n  </div>\n</ng-template>\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: ClearCartDialogComponentService
  }], {
    handleClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ClearCartDialogModule {
  static {
    this.ɵfac = function ClearCartDialogModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ClearCartDialogModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ClearCartDialogModule,
      declarations: [ClearCartDialogComponent],
      imports: [CommonModule, SpinnerModule, I18nModule, IconModule, KeyboardFocusModule, FeaturesConfigModule],
      exports: [ClearCartDialogComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SpinnerModule, I18nModule, IconModule, KeyboardFocusModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClearCartDialogModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, SpinnerModule, I18nModule, IconModule, KeyboardFocusModule, FeaturesConfigModule],
      declarations: [ClearCartDialogComponent],
      exports: [ClearCartDialogComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultClearCartLayoutConfig = {
  launch: {
    CLEAR_CART: {
      inline: true,
      component: ClearCartDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ClearCartModule {
  static {
    this.ɵfac = function ClearCartModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ClearCartModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ClearCartModule,
      declarations: [ClearCartComponent],
      imports: [CommonModule, I18nModule, ClearCartDialogModule],
      exports: [ClearCartComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ClearCartComponent: {
            component: ClearCartComponent
          }
        }
      }), provideDefaultConfig(defaultClearCartLayoutConfig)],
      imports: [CommonModule, I18nModule, ClearCartDialogModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClearCartModule, [{
    type: NgModule,
    args: [{
      declarations: [ClearCartComponent],
      exports: [ClearCartComponent],
      imports: [CommonModule, I18nModule, ClearCartDialogModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ClearCartComponent: {
            component: ClearCartComponent
          }
        }
      }), provideDefaultConfig(defaultClearCartLayoutConfig)]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartValidationWarningsComponent {
  constructor(cartValidationFacade) {
    this.cartValidationFacade = cartValidationFacade;
    this.iconTypes = ICON_TYPE;
    this.visibleWarnings = {};
    this.cartModifications$ = this.cartValidationFacade.getValidationResults().pipe(map(modificationList => {
      const result = modificationList.filter(modification => modification.statusCode === CartValidationStatusCode.NO_STOCK);
      result.forEach(modification => {
        if (modification.entry?.product?.code) {
          this.visibleWarnings[modification.entry.product.code] = true;
        }
      });
      return result;
    }));
  }
  removeMessage(cartModification) {
    if (cartModification.entry?.product?.code) {
      this.visibleWarnings[cartModification.entry.product.code] = false;
    }
  }
  static {
    this.ɵfac = function CartValidationWarningsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartValidationWarningsComponent)(i0.ɵɵdirectiveInject(i1.CartValidationFacade));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CartValidationWarningsComponent,
      selectors: [["cx-cart-validation-warnings"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngFor", "ngForOf"], ["class", "alert alert-danger", 4, "ngIf"], [1, "alert", "alert-danger"], [1, "alert-icon"], [3, "type"], [3, "routerLink"], ["type", "button", 1, "close", 3, "click", "title"]],
      template: function CartValidationWarningsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CartValidationWarningsComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(1, 1, ctx.cartModifications$));
        }
      },
      dependencies: [i4.NgForOf, i4.NgIf, i1$1.RouterLink, i2$1.IconComponent, i4.AsyncPipe, i2.TranslatePipe, i2.UrlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartValidationWarningsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-cart-validation-warnings',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngFor=\"let cartModification of cartModifications$ | async\">\n  <div\n    class=\"alert alert-danger\"\n    *ngIf=\"visibleWarnings[cartModification.entry.product.code]\"\n  >\n    <span class=\"alert-icon\">\n      <cx-icon [type]=\"iconTypes.ERROR\"></cx-icon>\n    </span>\n    <span>\n      <a\n        [routerLink]=\"\n          { cxRoute: 'product', params: cartModification.entry.product } | cxUrl\n        \"\n      >\n        {{ cartModification.entry.product.name }}\n      </a>\n      {{ 'validation.productOutOfStock' | cxTranslate }}\n    </span>\n\n    <button\n      class=\"close\"\n      type=\"button\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      [attr.aria-label]=\"'common.close' | cxTranslate\"\n      (click)=\"removeMessage(cartModification)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.CartValidationFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartDetailsComponent {
  constructor(activeCartService, selectiveCartService, authService, routingService, cartConfig) {
    this.activeCartService = activeCartService;
    this.selectiveCartService = selectiveCartService;
    this.authService = authService;
    this.routingService = routingService;
    this.cartConfig = cartConfig;
    this.loggedIn = false;
    this.promotionLocation = PromotionLocation.ActiveCart;
  }
  ngOnInit() {
    this.cart$ = this.activeCartService.getActive();
    this.entries$ = this.activeCartService.getEntries().pipe(filter(entries => entries.length > 0));
    this.selectiveCartEnabled = this.cartConfig.isSelectiveCartEnabled();
    this.cartLoaded$ = combineLatest([this.activeCartService.isStable(), this.selectiveCartEnabled ? this.selectiveCartService.isStable() : of(false), this.authService.isUserLoggedIn()]).pipe(tap(([,, loggedIn]) => this.loggedIn = loggedIn), map(([cartLoaded, sflLoaded, loggedIn]) => loggedIn && this.selectiveCartEnabled ? cartLoaded && sflLoaded : cartLoaded));
  }
  saveForLater(item) {
    if (this.loggedIn) {
      this.activeCartService.removeEntry(item);
      this.selectiveCartService.addEntry(item.product?.code ?? '', item.quantity ?? 0);
    } else {
      this.routingService.go({
        cxRoute: 'login'
      });
    }
  }
  static {
    this.ɵfac = function CartDetailsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartDetailsComponent)(i0.ɵɵdirectiveInject(i1.ActiveCartFacade), i0.ɵɵdirectiveInject(i1.SelectiveCartFacade), i0.ɵɵdirectiveInject(i2.AuthService), i0.ɵɵdirectiveInject(i2.RoutingService), i0.ɵɵdirectiveInject(i3.CartConfigService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CartDetailsComponent,
      selectors: [["cx-cart-details"]],
      standalone: false,
      decls: 4,
      vars: 3,
      consts: [["saveForLaterBtn", ""], [4, "ngIf"], ["class", "cart-details-wrapper", 4, "ngIf"], [1, "cart-details-wrapper"], [1, "cx-total"], [3, "promotions"], [3, "items", "cartIsLoading", "promotionLocation", "options"], ["class", "btn btn-tertiary cx-sfl-btn", "type", "button", 3, "disabled", "click", 4, "ngIf"], ["type", "button", 1, "btn", "btn-tertiary", "cx-sfl-btn", 3, "click", "disabled"]],
      template: function CartDetailsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CartDetailsComponent_ng_container_0_Template, 3, 3, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, CartDetailsComponent_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.cart$));
        }
      },
      dependencies: [CartItemListComponent, i4.NgIf, i2$1.PromotionsComponent, CartValidationWarningsComponent, i4.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartDetailsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-cart-details',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"cart$ | async as cart\">\n  <ng-container *ngIf=\"entries$ | async as entries\">\n    <div *ngIf=\"cart.totalItems > 0\" class=\"cart-details-wrapper\">\n      <cx-cart-validation-warnings></cx-cart-validation-warnings>\n\n      <h2 class=\"cx-total\">\n        {{ 'cartDetails.cartName' | cxTranslate: { code: cart.code } }}\n      </h2>\n\n      <cx-promotions\n        [promotions]=\"\n          (cart.appliedOrderPromotions || []).concat(\n            cart.potentialOrderPromotions || []\n          )\n        \"\n      ></cx-promotions>\n\n      <cx-cart-item-list\n        [items]=\"entries\"\n        [cartIsLoading]=\"!(cartLoaded$ | async)\"\n        [promotionLocation]=\"promotionLocation\"\n        [options]=\"{\n          isSaveForLater: false,\n          optionalBtn: saveForLaterBtn,\n        }\"\n      ></cx-cart-item-list>\n    </div>\n  </ng-container>\n</ng-container>\n\n<ng-template let-ctx #saveForLaterBtn>\n  <button\n    *ngIf=\"selectiveCartEnabled\"\n    class=\"btn btn-tertiary cx-sfl-btn\"\n    [disabled]=\"ctx.loading\"\n    (click)=\"saveForLater(ctx.item)\"\n    type=\"button\"\n  >\n    {{ 'saveForLaterItems.saveForLater' | cxTranslate }}\n  </button>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1.ActiveCartFacade
  }, {
    type: i1.SelectiveCartFacade
  }, {
    type: i2.AuthService
  }, {
    type: i2.RoutingService
  }, {
    type: i3.CartConfigService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartValidationWarningsModule {
  static {
    this.ɵfac = function CartValidationWarningsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartValidationWarningsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CartValidationWarningsModule,
      declarations: [CartValidationWarningsComponent],
      imports: [CommonModule, RouterModule, I18nModule, UrlModule, IconModule],
      exports: [CartValidationWarningsComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule, I18nModule, UrlModule, IconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartValidationWarningsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, I18nModule, UrlModule, IconModule],
      exports: [CartValidationWarningsComponent],
      declarations: [CartValidationWarningsComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartDetailsModule {
  static {
    this.ɵfac = function CartDetailsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartDetailsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CartDetailsModule,
      declarations: [CartDetailsComponent],
      imports: [CartSharedModule, CommonModule, CartCouponModule, RouterModule, UrlModule, PromotionsModule, I18nModule, CartValidationWarningsModule],
      exports: [CartDetailsComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          CartComponent: {
            component: CartDetailsComponent
          }
        }
      })],
      imports: [CartSharedModule, CommonModule, CartCouponModule, RouterModule, UrlModule, PromotionsModule, I18nModule, CartValidationWarningsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartDetailsModule, [{
    type: NgModule,
    args: [{
      imports: [CartSharedModule, CommonModule, CartCouponModule, RouterModule, UrlModule, PromotionsModule, I18nModule, CartValidationWarningsModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          CartComponent: {
            component: CartDetailsComponent
          }
        }
      })],
      declarations: [CartDetailsComponent],
      exports: [CartDetailsComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartPageLayoutHandler {
  constructor(activeCartService, selectiveCartService, cartConfig) {
    this.activeCartService = activeCartService;
    this.selectiveCartService = selectiveCartService;
    this.cartConfig = cartConfig;
  }
  handle(slots$, pageTemplate, section) {
    if (pageTemplate === 'CartPageTemplate' && !section) {
      return combineLatest([slots$, this.activeCartService.getActive(), this.getSelectiveCart(), this.activeCartService.getLoading()]).pipe(map(([slots, cart, selectiveCart, loadingCart]) => {
        const exclude = (arr, args) => arr.filter(item => args.every(arg => arg !== item));
        return isEmpty(cart) && loadingCart ? exclude(slots, ['TopContent', 'CenterRightContentSlot', 'EmptyCartMiddleContent']) : cart.totalItems ? exclude(slots, ['EmptyCartMiddleContent']) : selectiveCart?.totalItems ? exclude(slots, ['EmptyCartMiddleContent', 'CenterRightContentSlot']) : exclude(slots, ['TopContent', 'CenterRightContentSlot']);
      }));
    }
    return slots$;
  }
  getSelectiveCart() {
    return this.cartConfig.isSelectiveCartEnabled() ? this.selectiveCartService.getCart().pipe(startWith(null)) : of({});
  }
  static {
    this.ɵfac = function CartPageLayoutHandler_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartPageLayoutHandler)(i0.ɵɵinject(i1.ActiveCartFacade), i0.ɵɵinject(i1.SelectiveCartFacade), i0.ɵɵinject(i3.CartConfigService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CartPageLayoutHandler,
      factory: CartPageLayoutHandler.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartPageLayoutHandler, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ActiveCartFacade
  }, {
    type: i1.SelectiveCartFacade
  }, {
    type: i3.CartConfigService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartProceedToCheckoutComponent {
  constructor(router, cd) {
    this.router = router;
    this.cd = cd;
    this.cartValidationInProgress = false;
    this.subscription = new Subscription();
  }
  ngOnInit() {
    this.subscription.add(this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        this.cartValidationInProgress = false;
        this.cd?.markForCheck();
      }
    }));
  }
  disableButtonWhileNavigation() {
    this.cartValidationInProgress = true;
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function CartProceedToCheckoutComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartProceedToCheckoutComponent)(i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CartProceedToCheckoutComponent,
      selectors: [["cx-cart-proceed-to-checkout"]],
      standalone: false,
      decls: 4,
      vars: 11,
      consts: [["tabindex", "-1", 3, "clickEvent", "disabled", "loading", "routerLink"]],
      template: function CartProceedToCheckoutComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "cx-progress-button", 0);
          i0.ɵɵpipe(1, "cxUrl");
          i0.ɵɵlistener("clickEvent", function CartProceedToCheckoutComponent_Template_cx_progress_button_clickEvent_0_listener() {
            return ctx.disableButtonWhileNavigation();
          });
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "cxTranslate");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap("btn btn-primary btn-block");
          i0.ɵɵproperty("disabled", ctx.cartValidationInProgress)("loading", ctx.cartValidationInProgress)("routerLink", i0.ɵɵpipeBind1(1, 6, i0.ɵɵpureFunction0(10, _c14)));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 8, ctx.cartValidationInProgress ? "validation.inProgress" : "cartDetails.proceedToCheckout"), "\n");
        }
      },
      dependencies: [i2$1.ProgressButtonComponent, i1$1.RouterLink, i2.TranslatePipe, i2.UrlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartProceedToCheckoutComponent, [{
    type: Component,
    args: [{
      selector: 'cx-cart-proceed-to-checkout',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-progress-button\n  (clickEvent)=\"disableButtonWhileNavigation()\"\n  [class]=\"'btn btn-primary btn-block'\"\n  [disabled]=\"cartValidationInProgress\"\n  [loading]=\"cartValidationInProgress\"\n  [routerLink]=\"{ cxRoute: 'checkout' } | cxUrl\"\n  tabindex=\"-1\"\n>\n  {{\n    (cartValidationInProgress\n      ? 'validation.inProgress'\n      : 'cartDetails.proceedToCheckout'\n    ) | cxTranslate\n  }}\n</cx-progress-button>\n"
    }]
  }], () => [{
    type: i1$1.Router
  }, {
    type: i0.ChangeDetectorRef
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartProceedToCheckoutModule {
  static {
    this.ɵfac = function CartProceedToCheckoutModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartProceedToCheckoutModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CartProceedToCheckoutModule,
      declarations: [CartProceedToCheckoutComponent],
      imports: [CommonModule, ProgressButtonModule, RouterModule, I18nModule, UrlModule],
      exports: [CartProceedToCheckoutComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          CartProceedToCheckoutComponent: {
            component: CartProceedToCheckoutComponent
          }
        }
      })],
      imports: [CommonModule, ProgressButtonModule, RouterModule, I18nModule, UrlModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartProceedToCheckoutModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ProgressButtonModule, RouterModule, I18nModule, UrlModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          CartProceedToCheckoutComponent: {
            component: CartProceedToCheckoutComponent
          }
        }
      })],
      declarations: [CartProceedToCheckoutComponent],
      exports: [CartProceedToCheckoutComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartTotalsComponent {
  constructor(activeCartService) {
    this.activeCartService = activeCartService;
  }
  ngOnInit() {
    this.cart$ = this.activeCartService.getActive();
  }
  static {
    this.ɵfac = function CartTotalsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartTotalsComponent)(i0.ɵɵdirectiveInject(i1.ActiveCartFacade));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CartTotalsComponent,
      selectors: [["cx-cart-totals"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [3, "cart"]],
      template: function CartTotalsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CartTotalsComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.cart$));
        }
      },
      dependencies: [i4.NgIf, OrderSummaryComponent, i4.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartTotalsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-cart-totals',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"cart$ | async as cart\">\n  <cx-order-summary [cart]=\"cart\"></cx-order-summary>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.ActiveCartFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartTotalsModule {
  static {
    this.ɵfac = function CartTotalsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartTotalsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CartTotalsModule,
      declarations: [CartTotalsComponent],
      imports: [CommonModule, CartSharedModule],
      exports: [CartTotalsComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          CartTotalsComponent: {
            component: CartTotalsComponent
          }
        }
      })],
      imports: [CommonModule, CartSharedModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartTotalsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, CartSharedModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          CartTotalsComponent: {
            component: CartTotalsComponent
          }
        }
      })],
      declarations: [CartTotalsComponent],
      exports: [CartTotalsComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ActiveCartOrderEntriesContext {
  constructor(importInfoService, activeCartFacade) {
    this.importInfoService = importInfoService;
    this.activeCartFacade = activeCartFacade;
    this.type = OrderEntriesSource.ACTIVE_CART;
  }
  addEntries(products) {
    return this.add(products).pipe(switchMap(cartId => this.importInfoService.getResults(cartId)), take(products.length));
  }
  getEntries() {
    return this.activeCartFacade.getEntries();
  }
  add(products) {
    this.activeCartFacade.addEntries(this.mapProductsToOrderEntries(products));
    return this.activeCartFacade.getActiveCartId();
  }
  mapProductsToOrderEntries(products) {
    return products.map(product => ({
      product: {
        code: product.productCode
      },
      quantity: product.quantity
    }));
  }
  static {
    this.ɵfac = function ActiveCartOrderEntriesContext_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ActiveCartOrderEntriesContext)(i0.ɵɵinject(i3.ProductImportInfoService), i0.ɵɵinject(i1.ActiveCartFacade));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ActiveCartOrderEntriesContext,
      factory: ActiveCartOrderEntriesContext.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ActiveCartOrderEntriesContext, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i3.ProductImportInfoService
  }, {
    type: i1.ActiveCartFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SaveForLaterComponent {
  constructor(cmsService, cartService, selectiveCartService) {
    this.cmsService = cmsService;
    this.cartService = cartService;
    this.selectiveCartService = selectiveCartService;
    this.CartLocation = PromotionLocation;
  }
  ngOnInit() {
    this.isCartEmpty$ = this.cartService.getActive().pipe(map(cart => !(cart && cart.totalItems && cart.totalItems > 0)));
    this.saveForLater$ = this.selectiveCartService.getCart();
    this.entries$ = this.selectiveCartService.getEntries().pipe(filter(entries => entries.length > 0));
    this.cartLoaded$ = combineLatest([this.cartService.isStable(), this.selectiveCartService.isStable()]).pipe(map(([cartLoaded, sflLoaded]) => cartLoaded && sflLoaded));
    this.data$ = this.cmsService.getComponentData('EmptyCartParagraphComponent');
  }
  moveToCart(item) {
    this.selectiveCartService.removeEntry(item);
    this.cartService.addEntry(item.product?.code ?? '', item.quantity ?? 0);
  }
  static {
    this.ɵfac = function SaveForLaterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SaveForLaterComponent)(i0.ɵɵdirectiveInject(i2.CmsService), i0.ɵɵdirectiveInject(i1.ActiveCartFacade), i0.ɵɵdirectiveInject(i1.SelectiveCartFacade));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SaveForLaterComponent,
      selectors: [["cx-save-for-later"]],
      standalone: false,
      decls: 6,
      vars: 6,
      consts: [["moveToCartBtn", ""], [4, "ngIf"], ["class", "cx-empty-cart-info", 3, "innerHTML", 4, "ngIf"], [1, "cx-empty-cart-info", 3, "innerHTML"], ["class", "cart-details-wrapper", 4, "ngIf"], [1, "cart-details-wrapper"], [1, "cx-total"], [3, "items", "readonly", "cartIsLoading", "promotionLocation", "options"], ["type", "button", 1, "btn", "btn-tertiary", "cx-sfl-btn", 3, "click", "disabled"]],
      template: function SaveForLaterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SaveForLaterComponent_ng_container_0_Template, 3, 3, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, SaveForLaterComponent_ng_container_2_Template, 3, 3, "ng-container", 1);
          i0.ɵɵpipe(3, "async");
          i0.ɵɵtemplate(4, SaveForLaterComponent_ng_template_4_Template, 3, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.isCartEmpty$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx.saveForLater$));
        }
      },
      dependencies: [i4.NgIf, CartItemListComponent, i4.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SaveForLaterComponent, [{
    type: Component,
    args: [{
      selector: 'cx-save-for-later',
      standalone: false,
      template: "<ng-container *ngIf=\"isCartEmpty$ | async\">\n  <p\n    *ngIf=\"data$ | async as data\"\n    [innerHTML]=\"data.content\"\n    class=\"cx-empty-cart-info\"\n  ></p>\n</ng-container>\n\n<ng-container *ngIf=\"saveForLater$ | async as saveForLater\">\n  <ng-container *ngIf=\"entries$ | async as entries\">\n    <div *ngIf=\"saveForLater.totalItems > 0\" class=\"cart-details-wrapper\">\n      <div class=\"cx-total\">\n        {{\n          'saveForLaterItems.itemTotal'\n            | cxTranslate: { count: saveForLater.totalItems }\n        }}\n      </div>\n      <cx-cart-item-list\n        [items]=\"entries\"\n        [readonly]=\"false\"\n        [cartIsLoading]=\"!(cartLoaded$ | async)\"\n        [promotionLocation]=\"CartLocation.SaveForLater\"\n        [options]=\"{\n          isSaveForLater: true,\n          optionalBtn: moveToCartBtn,\n        }\"\n      ></cx-cart-item-list>\n    </div>\n  </ng-container>\n</ng-container>\n\n<ng-template let-ctx #moveToCartBtn>\n  <button\n    class=\"btn btn-tertiary cx-sfl-btn\"\n    [disabled]=\"ctx.loading\"\n    (click)=\"moveToCart(ctx.item)\"\n    type=\"button\"\n  >\n    {{ 'saveForLaterItems.moveToCart' | cxTranslate }}\n  </button>\n</ng-template>\n"
    }]
  }], () => [{
    type: i2.CmsService
  }, {
    type: i1.ActiveCartFacade
  }, {
    type: i1.SelectiveCartFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SaveForLaterModule {
  static {
    this.ɵfac = function SaveForLaterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SaveForLaterModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SaveForLaterModule,
      declarations: [SaveForLaterComponent],
      imports: [CommonModule, I18nModule, CartSharedModule],
      exports: [SaveForLaterComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          SaveForLaterComponent: {
            component: SaveForLaterComponent
          }
        }
      })],
      imports: [CommonModule, I18nModule, CartSharedModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SaveForLaterModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule, CartSharedModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          SaveForLaterComponent: {
            component: SaveForLaterComponent
          }
        }
      })],
      declarations: [SaveForLaterComponent],
      exports: [SaveForLaterComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartBaseComponentsModule {
  static {
    this.ɵfac = function CartBaseComponentsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartBaseComponentsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CartBaseComponentsModule,
      imports: [CommonModule, CartDetailsModule, CartProceedToCheckoutModule, CartTotalsModule, CartSharedModule, SaveForLaterModule, ClearCartModule, i2$1.OutletModule],
      exports: [CartDetailsModule, CartProceedToCheckoutModule, CartTotalsModule, CartSharedModule, ClearCartModule, AddedToCartDialogModule, SaveForLaterModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: PAGE_LAYOUT_HANDLER,
        useExisting: CartPageLayoutHandler,
        multi: true
      }, {
        provide: ActiveCartOrderEntriesContextToken,
        useExisting: ActiveCartOrderEntriesContext
      }],
      imports: [CommonModule, CartDetailsModule, CartProceedToCheckoutModule, CartTotalsModule, CartSharedModule, SaveForLaterModule, ClearCartModule, OutletModule.forChild(), CartDetailsModule, CartProceedToCheckoutModule, CartTotalsModule, CartSharedModule, ClearCartModule, AddedToCartDialogModule, SaveForLaterModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartBaseComponentsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, CartDetailsModule, CartProceedToCheckoutModule, CartTotalsModule, CartSharedModule, SaveForLaterModule, ClearCartModule, OutletModule.forChild()],
      exports: [CartDetailsModule, CartProceedToCheckoutModule, CartTotalsModule, CartSharedModule, ClearCartModule, AddedToCartDialogModule, SaveForLaterModule],
      providers: [{
        provide: PAGE_LAYOUT_HANDLER,
        useExisting: CartPageLayoutHandler,
        multi: true
      }, {
        provide: ActiveCartOrderEntriesContextToken,
        useExisting: ActiveCartOrderEntriesContext
      }]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CartValidationComponentsModule {
  static {
    this.ɵfac = function CartValidationComponentsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartValidationComponentsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CartValidationComponentsModule,
      imports: [CartValidationWarningsModule, CartItemValidationWarningModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CartValidationWarningsModule, CartItemValidationWarningModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartValidationComponentsModule, [{
    type: NgModule,
    args: [{
      imports: [CartValidationWarningsModule, CartItemValidationWarningModule],
      providers: []
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractOrderContext, AbstractOrderContextDirective, AbstractOrderContextModule, AbstractOrderContextSource, ActiveCartOrderEntriesContext, AddedToCartDialogComponent, AddedToCartDialogEventListener, AddedToCartDialogModule, AppliedCouponsComponent, CartBaseComponentsModule, CartCouponComponent, CartCouponModule, CartDetailsComponent, CartDetailsModule, CartItemComponent, CartItemContextSource, CartItemListComponent, CartItemListComponentService, CartItemListRowComponent, CartPageLayoutHandler, CartProceedToCheckoutComponent, CartProceedToCheckoutModule, CartSharedModule, CartTotalsComponent, CartTotalsModule, CartValidationComponentsModule, CartValidationWarningsComponent, CartValidationWarningsModule, ClearCartComponent, ClearCartDialogComponent, ClearCartDialogComponentService, ClearCartDialogModule, ClearCartModule, OrderSummaryComponent, SaveForLaterComponent, SaveForLaterModule, defaultClearCartLayoutConfig };
